import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigFloat: { input: any; output: any; }
  Cursor: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type CarModel = Node & {
  __typename?: 'CarModel';
  /** Reads and enables pagination through a set of `CarsForSale`. */
  carsForSalesByIdCarModel: CarsForSalesConnection;
  id: Scalars['Int']['output'];
  idPopularMake: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `PopularMake` that is related to this `CarModel`. */
  popularMakeByIdPopularMake?: Maybe<PopularMake>;
};


export type CarModelCarsForSalesByIdCarModelArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarsForSaleCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};

/**
 * A condition to be used against `CarModel` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CarModelCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `idPopularMake` field. */
  idPopularMake?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An input for mutations affecting `CarModel` */
export type CarModelInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  idPopularMake: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** Represents an update to a `CarModel`. Fields that are set will be updated. */
export type CarModelPatch = {
  id?: InputMaybe<Scalars['Int']['input']>;
  idPopularMake?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CarModel` values. */
export type CarModelsConnection = {
  __typename?: 'CarModelsConnection';
  /** A list of edges which contains the `CarModel` and cursor to aid in pagination. */
  edges: Array<CarModelsEdge>;
  /** A list of `CarModel` objects. */
  nodes: Array<Maybe<CarModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CarModel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CarModel` edge in the connection. */
export type CarModelsEdge = {
  __typename?: 'CarModelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CarModel` at the end of the edge. */
  node?: Maybe<CarModel>;
};

/** Methods to use when ordering `CarModel`. */
export enum CarModelsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IdPopularMakeAsc = 'ID_POPULAR_MAKE_ASC',
  IdPopularMakeDesc = 'ID_POPULAR_MAKE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CarsForSale = Node & {
  __typename?: 'CarsForSale';
  active: Scalars['Boolean']['output'];
  bodyStyle?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CarModel` that is related to this `CarsForSale`. */
  carModelByIdCarModel?: Maybe<CarModel>;
  catalogMatchConfidence?: Maybe<Scalars['BigFloat']['output']>;
  catalogMatchStage?: Maybe<Scalars['String']['output']>;
  catalogSourceId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Conversation`. */
  conversationsByListingId: ConversationsConnection;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  driveType?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  exteriorColor?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  hasVerifiedTitle?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  idCarMake?: Maybe<Scalars['Int']['output']>;
  idCarModel?: Maybe<Scalars['Int']['output']>;
  identityConfidenceRaw?: Maybe<Scalars['String']['output']>;
  identityConfidenceScore?: Maybe<Scalars['BigFloat']['output']>;
  identityDecodedAt?: Maybe<Scalars['Datetime']['output']>;
  identityDisplayTitle?: Maybe<Scalars['String']['output']>;
  identityProvider?: Maybe<Scalars['String']['output']>;
  identityProviderTier?: Maybe<Scalars['String']['output']>;
  identitySnapshot?: Maybe<Scalars['JSON']['output']>;
  identityStyleKey?: Maybe<Scalars['String']['output']>;
  identityVersion?: Maybe<Scalars['String']['output']>;
  imageLoc?: Maybe<Scalars['JSON']['output']>;
  interiorColor?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['BigFloat']['output']>;
  locationAddress?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['BigFloat']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  normalizedMake?: Maybe<Scalars['String']['output']>;
  normalizedModel?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PopularMake` that is related to this `CarsForSale`. */
  popularMakeByIdCarMake?: Maybe<PopularMake>;
  price: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `PublicComment`. */
  publicCommentsByListingId: PublicCommentsConnection;
  sellerId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `SellerReview`. */
  sellerReviewsByListingId: SellerReviewsConnection;
  sold?: Maybe<Scalars['Boolean']['output']>;
  soldAt?: Maybe<Scalars['Datetime']['output']>;
  soldToUserId?: Maybe<Scalars['Int']['output']>;
  titleImageKey?: Maybe<Scalars['String']['output']>;
  titleStatus?: Maybe<Scalars['String']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  trim?: Maybe<Scalars['String']['output']>;
  unmatchedCatalog: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySellerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySoldToUserId?: Maybe<User>;
  /** Reads a single `VehicleCatalog` that is related to this `CarsForSale`. */
  vehicleCatalogByCatalogSourceId?: Maybe<VehicleCatalog>;
  vin?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};


export type CarsForSaleConversationsByListingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConversationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


export type CarsForSalePublicCommentsByListingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PublicCommentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublicCommentsOrderBy>>;
};


export type CarsForSaleSellerReviewsByListingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SellerReviewCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SellerReviewsOrderBy>>;
};

/**
 * A condition to be used against `CarsForSale` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CarsForSaleCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `bodyStyle` field. */
  bodyStyle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `catalogMatchConfidence` field. */
  catalogMatchConfidence?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `catalogMatchStage` field. */
  catalogMatchStage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `catalogSourceId` field. */
  catalogSourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `driveType` field. */
  driveType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `engine` field. */
  engine?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `exteriorColor` field. */
  exteriorColor?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fuelType` field. */
  fuelType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hasVerifiedTitle` field. */
  hasVerifiedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `idCarMake` field. */
  idCarMake?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `idCarModel` field. */
  idCarModel?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `imageLoc` field. */
  imageLoc?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `interiorColor` field. */
  interiorColor?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `locationAddress` field. */
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `make` field. */
  make?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mileage` field. */
  mileage?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `model` field. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `normalizedMake` field. */
  normalizedMake?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `normalizedModel` field. */
  normalizedModel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sellerId` field. */
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sold` field. */
  sold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `soldAt` field. */
  soldAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `soldToUserId` field. */
  soldToUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `titleImageKey` field. */
  titleImageKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `titleStatus` field. */
  titleStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `transmission` field. */
  transmission?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `trim` field. */
  trim?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `unmatchedCatalog` field. */
  unmatchedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vin` field. */
  vin?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `CarsForSale` */
export type CarsForSaleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bodyStyle?: InputMaybe<Scalars['String']['input']>;
  catalogMatchConfidence?: InputMaybe<Scalars['BigFloat']['input']>;
  catalogMatchStage?: InputMaybe<Scalars['String']['input']>;
  catalogSourceId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driveType?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  exteriorColor?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  hasVerifiedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idCarMake?: InputMaybe<Scalars['Int']['input']>;
  idCarModel?: InputMaybe<Scalars['Int']['input']>;
  identityConfidenceRaw?: InputMaybe<Scalars['String']['input']>;
  identityConfidenceScore?: InputMaybe<Scalars['BigFloat']['input']>;
  identityDecodedAt?: InputMaybe<Scalars['Datetime']['input']>;
  identityDisplayTitle?: InputMaybe<Scalars['String']['input']>;
  identityProvider?: InputMaybe<Scalars['String']['input']>;
  identityProviderTier?: InputMaybe<Scalars['String']['input']>;
  identitySnapshot?: InputMaybe<Scalars['JSON']['input']>;
  identityStyleKey?: InputMaybe<Scalars['String']['input']>;
  identityVersion?: InputMaybe<Scalars['String']['input']>;
  imageLoc?: InputMaybe<Scalars['JSON']['input']>;
  interiorColor?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  normalizedMake?: InputMaybe<Scalars['String']['input']>;
  normalizedModel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['BigFloat']['input'];
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  sold?: InputMaybe<Scalars['Boolean']['input']>;
  soldAt?: InputMaybe<Scalars['Datetime']['input']>;
  soldToUserId?: InputMaybe<Scalars['Int']['input']>;
  titleImageKey?: InputMaybe<Scalars['String']['input']>;
  titleStatus?: InputMaybe<Scalars['String']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  unmatchedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

/** Represents an update to a `CarsForSale`. Fields that are set will be updated. */
export type CarsForSalePatch = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bodyStyle?: InputMaybe<Scalars['String']['input']>;
  catalogMatchConfidence?: InputMaybe<Scalars['BigFloat']['input']>;
  catalogMatchStage?: InputMaybe<Scalars['String']['input']>;
  catalogSourceId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driveType?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  exteriorColor?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  hasVerifiedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idCarMake?: InputMaybe<Scalars['Int']['input']>;
  idCarModel?: InputMaybe<Scalars['Int']['input']>;
  imageLoc?: InputMaybe<Scalars['JSON']['input']>;
  interiorColor?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  normalizedMake?: InputMaybe<Scalars['String']['input']>;
  normalizedModel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  sold?: InputMaybe<Scalars['Boolean']['input']>;
  soldAt?: InputMaybe<Scalars['Datetime']['input']>;
  soldToUserId?: InputMaybe<Scalars['Int']['input']>;
  titleImageKey?: InputMaybe<Scalars['String']['input']>;
  titleStatus?: InputMaybe<Scalars['String']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  unmatchedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CarsForSale` values. */
export type CarsForSalesConnection = {
  __typename?: 'CarsForSalesConnection';
  /** A list of edges which contains the `CarsForSale` and cursor to aid in pagination. */
  edges: Array<CarsForSalesEdge>;
  /** A list of `CarsForSale` objects. */
  nodes: Array<Maybe<CarsForSale>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CarsForSale` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CarsForSale` edge in the connection. */
export type CarsForSalesEdge = {
  __typename?: 'CarsForSalesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CarsForSale` at the end of the edge. */
  node?: Maybe<CarsForSale>;
};

/** Methods to use when ordering `CarsForSale`. */
export enum CarsForSalesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  BodyStyleAsc = 'BODY_STYLE_ASC',
  BodyStyleDesc = 'BODY_STYLE_DESC',
  CatalogMatchConfidenceAsc = 'CATALOG_MATCH_CONFIDENCE_ASC',
  CatalogMatchConfidenceDesc = 'CATALOG_MATCH_CONFIDENCE_DESC',
  CatalogMatchStageAsc = 'CATALOG_MATCH_STAGE_ASC',
  CatalogMatchStageDesc = 'CATALOG_MATCH_STAGE_DESC',
  CatalogSourceIdAsc = 'CATALOG_SOURCE_ID_ASC',
  CatalogSourceIdDesc = 'CATALOG_SOURCE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DriveTypeAsc = 'DRIVE_TYPE_ASC',
  DriveTypeDesc = 'DRIVE_TYPE_DESC',
  EngineAsc = 'ENGINE_ASC',
  EngineDesc = 'ENGINE_DESC',
  ExteriorColorAsc = 'EXTERIOR_COLOR_ASC',
  ExteriorColorDesc = 'EXTERIOR_COLOR_DESC',
  FuelTypeAsc = 'FUEL_TYPE_ASC',
  FuelTypeDesc = 'FUEL_TYPE_DESC',
  HasVerifiedTitleAsc = 'HAS_VERIFIED_TITLE_ASC',
  HasVerifiedTitleDesc = 'HAS_VERIFIED_TITLE_DESC',
  IdAsc = 'ID_ASC',
  IdCarMakeAsc = 'ID_CAR_MAKE_ASC',
  IdCarMakeDesc = 'ID_CAR_MAKE_DESC',
  IdCarModelAsc = 'ID_CAR_MODEL_ASC',
  IdCarModelDesc = 'ID_CAR_MODEL_DESC',
  IdDesc = 'ID_DESC',
  ImageLocAsc = 'IMAGE_LOC_ASC',
  ImageLocDesc = 'IMAGE_LOC_DESC',
  InteriorColorAsc = 'INTERIOR_COLOR_ASC',
  InteriorColorDesc = 'INTERIOR_COLOR_DESC',
  LatitudeAsc = 'LATITUDE_ASC',
  LatitudeDesc = 'LATITUDE_DESC',
  LocationAddressAsc = 'LOCATION_ADDRESS_ASC',
  LocationAddressDesc = 'LOCATION_ADDRESS_DESC',
  LongitudeAsc = 'LONGITUDE_ASC',
  LongitudeDesc = 'LONGITUDE_DESC',
  MakeAsc = 'MAKE_ASC',
  MakeDesc = 'MAKE_DESC',
  MileageAsc = 'MILEAGE_ASC',
  MileageDesc = 'MILEAGE_DESC',
  ModelAsc = 'MODEL_ASC',
  ModelDesc = 'MODEL_DESC',
  Natural = 'NATURAL',
  NormalizedMakeAsc = 'NORMALIZED_MAKE_ASC',
  NormalizedMakeDesc = 'NORMALIZED_MAKE_DESC',
  NormalizedModelAsc = 'NORMALIZED_MODEL_ASC',
  NormalizedModelDesc = 'NORMALIZED_MODEL_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SellerIdAsc = 'SELLER_ID_ASC',
  SellerIdDesc = 'SELLER_ID_DESC',
  SoldAsc = 'SOLD_ASC',
  SoldAtAsc = 'SOLD_AT_ASC',
  SoldAtDesc = 'SOLD_AT_DESC',
  SoldDesc = 'SOLD_DESC',
  SoldToUserIdAsc = 'SOLD_TO_USER_ID_ASC',
  SoldToUserIdDesc = 'SOLD_TO_USER_ID_DESC',
  TitleImageKeyAsc = 'TITLE_IMAGE_KEY_ASC',
  TitleImageKeyDesc = 'TITLE_IMAGE_KEY_DESC',
  TitleStatusAsc = 'TITLE_STATUS_ASC',
  TitleStatusDesc = 'TITLE_STATUS_DESC',
  TransmissionAsc = 'TRANSMISSION_ASC',
  TransmissionDesc = 'TRANSMISSION_DESC',
  TrimAsc = 'TRIM_ASC',
  TrimDesc = 'TRIM_DESC',
  UnmatchedCatalogAsc = 'UNMATCHED_CATALOG_ASC',
  UnmatchedCatalogDesc = 'UNMATCHED_CATALOG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VinAsc = 'VIN_ASC',
  VinDesc = 'VIN_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

export type Conversation = Node & {
  __typename?: 'Conversation';
  buyerId: Scalars['Int']['output'];
  /** Reads a single `CarsForSale` that is related to this `Conversation`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `PrivateMessage`. */
  privateMessagesByConversationId: PrivateMessagesConnection;
  sellerId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userBySellerId?: Maybe<User>;
};


export type ConversationPrivateMessagesByConversationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PrivateMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PrivateMessagesOrderBy>>;
};

/**
 * A condition to be used against `Conversation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ConversationCondition = {
  /** Checks for equality with the object’s `buyerId` field. */
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `listingId` field. */
  listingId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sellerId` field. */
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An input for mutations affecting `Conversation` */
export type ConversationInput = {
  buyerId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listingId: Scalars['Int']['input'];
  sellerId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `Conversation`. Fields that are set will be updated. */
export type ConversationPatch = {
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listingId?: InputMaybe<Scalars['Int']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `Conversation` values. */
export type ConversationsConnection = {
  __typename?: 'ConversationsConnection';
  /** A list of edges which contains the `Conversation` and cursor to aid in pagination. */
  edges: Array<ConversationsEdge>;
  /** A list of `Conversation` objects. */
  nodes: Array<Maybe<Conversation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Conversation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Conversation` edge in the connection. */
export type ConversationsEdge = {
  __typename?: 'ConversationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Conversation` at the end of the edge. */
  node?: Maybe<Conversation>;
};

/** Methods to use when ordering `Conversation`. */
export enum ConversationsOrderBy {
  BuyerIdAsc = 'BUYER_ID_ASC',
  BuyerIdDesc = 'BUYER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ListingIdAsc = 'LISTING_ID_ASC',
  ListingIdDesc = 'LISTING_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SellerIdAsc = 'SELLER_ID_ASC',
  SellerIdDesc = 'SELLER_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the create `CarModel` mutation. */
export type CreateCarModelInput = {
  /** The `CarModel` to be created by this mutation. */
  carModel: CarModelInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CarModel` mutation. */
export type CreateCarModelPayload = {
  __typename?: 'CreateCarModelPayload';
  /** The `CarModel` that was created by this mutation. */
  carModel?: Maybe<CarModel>;
  /** An edge for our `CarModel`. May be used by Relay 1. */
  carModelEdge?: Maybe<CarModelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PopularMake` that is related to this `CarModel`. */
  popularMakeByIdPopularMake?: Maybe<PopularMake>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CarModel` mutation. */
export type CreateCarModelPayloadCarModelEdgeArgs = {
  orderBy?: InputMaybe<Array<CarModelsOrderBy>>;
};

/** All input for the create `CarsForSale` mutation. */
export type CreateCarsForSaleInput = {
  /** The `CarsForSale` to be created by this mutation. */
  carsForSale: CarsForSaleInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CarsForSale` mutation. */
export type CreateCarsForSalePayload = {
  __typename?: 'CreateCarsForSalePayload';
  /** Reads a single `CarModel` that is related to this `CarsForSale`. */
  carModelByIdCarModel?: Maybe<CarModel>;
  /** The `CarsForSale` that was created by this mutation. */
  carsForSale?: Maybe<CarsForSale>;
  /** An edge for our `CarsForSale`. May be used by Relay 1. */
  carsForSaleEdge?: Maybe<CarsForSalesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PopularMake` that is related to this `CarsForSale`. */
  popularMakeByIdCarMake?: Maybe<PopularMake>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySellerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySoldToUserId?: Maybe<User>;
  /** Reads a single `VehicleCatalog` that is related to this `CarsForSale`. */
  vehicleCatalogByCatalogSourceId?: Maybe<VehicleCatalog>;
};


/** The output of our create `CarsForSale` mutation. */
export type CreateCarsForSalePayloadCarsForSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};

/** All input for the create `Conversation` mutation. */
export type CreateConversationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Conversation` to be created by this mutation. */
  conversation: ConversationInput;
};

/** The output of our create `Conversation` mutation. */
export type CreateConversationPayload = {
  __typename?: 'CreateConversationPayload';
  /** Reads a single `CarsForSale` that is related to this `Conversation`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Conversation` that was created by this mutation. */
  conversation?: Maybe<Conversation>;
  /** An edge for our `Conversation`. May be used by Relay 1. */
  conversationEdge?: Maybe<ConversationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userBySellerId?: Maybe<User>;
};


/** The output of our create `Conversation` mutation. */
export type CreateConversationPayloadConversationEdgeArgs = {
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};

/** All input for the create `EmailVerificationPin` mutation. */
export type CreateEmailVerificationPinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EmailVerificationPin` to be created by this mutation. */
  emailVerificationPin: EmailVerificationPinInput;
};

/** The output of our create `EmailVerificationPin` mutation. */
export type CreateEmailVerificationPinPayload = {
  __typename?: 'CreateEmailVerificationPinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailVerificationPin` that was created by this mutation. */
  emailVerificationPin?: Maybe<EmailVerificationPin>;
  /** An edge for our `EmailVerificationPin`. May be used by Relay 1. */
  emailVerificationPinEdge?: Maybe<EmailVerificationPinsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailVerificationPin`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `EmailVerificationPin` mutation. */
export type CreateEmailVerificationPinPayloadEmailVerificationPinEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailVerificationPinsOrderBy>>;
};

/** All input for the create `EmailVerificationResend` mutation. */
export type CreateEmailVerificationResendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EmailVerificationResend` to be created by this mutation. */
  emailVerificationResend: EmailVerificationResendInput;
};

/** The output of our create `EmailVerificationResend` mutation. */
export type CreateEmailVerificationResendPayload = {
  __typename?: 'CreateEmailVerificationResendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailVerificationResend` that was created by this mutation. */
  emailVerificationResend?: Maybe<EmailVerificationResend>;
  /** An edge for our `EmailVerificationResend`. May be used by Relay 1. */
  emailVerificationResendEdge?: Maybe<EmailVerificationResendsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailVerificationResend`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `EmailVerificationResend` mutation. */
export type CreateEmailVerificationResendPayloadEmailVerificationResendEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailVerificationResendsOrderBy>>;
};

/** All input for the create `PopularMake` mutation. */
export type CreatePopularMakeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PopularMake` to be created by this mutation. */
  popularMake: PopularMakeInput;
};

/** The output of our create `PopularMake` mutation. */
export type CreatePopularMakePayload = {
  __typename?: 'CreatePopularMakePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PopularMake` that was created by this mutation. */
  popularMake?: Maybe<PopularMake>;
  /** An edge for our `PopularMake`. May be used by Relay 1. */
  popularMakeEdge?: Maybe<PopularMakesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PopularMake` mutation. */
export type CreatePopularMakePayloadPopularMakeEdgeArgs = {
  orderBy?: InputMaybe<Array<PopularMakesOrderBy>>;
};

/** All input for the create `PrivateMessage` mutation. */
export type CreatePrivateMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PrivateMessage` to be created by this mutation. */
  privateMessage: PrivateMessageInput;
};

/** The output of our create `PrivateMessage` mutation. */
export type CreatePrivateMessagePayload = {
  __typename?: 'CreatePrivateMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Conversation` that is related to this `PrivateMessage`. */
  conversationByConversationId?: Maybe<Conversation>;
  /** The `PrivateMessage` that was created by this mutation. */
  privateMessage?: Maybe<PrivateMessage>;
  /** An edge for our `PrivateMessage`. May be used by Relay 1. */
  privateMessageEdge?: Maybe<PrivateMessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PrivateMessage`. */
  userBySenderId?: Maybe<User>;
};


/** The output of our create `PrivateMessage` mutation. */
export type CreatePrivateMessagePayloadPrivateMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<PrivateMessagesOrderBy>>;
};

/** All input for the create `PublicComment` mutation. */
export type CreatePublicCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PublicComment` to be created by this mutation. */
  publicComment: PublicCommentInput;
};

/** The output of our create `PublicComment` mutation. */
export type CreatePublicCommentPayload = {
  __typename?: 'CreatePublicCommentPayload';
  /** Reads a single `CarsForSale` that is related to this `PublicComment`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PublicComment` that was created by this mutation. */
  publicComment?: Maybe<PublicComment>;
  /** Reads a single `PublicComment` that is related to this `PublicComment`. */
  publicCommentByParentCommentId?: Maybe<PublicComment>;
  /** An edge for our `PublicComment`. May be used by Relay 1. */
  publicCommentEdge?: Maybe<PublicCommentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PublicComment`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `PublicComment` mutation. */
export type CreatePublicCommentPayloadPublicCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PublicCommentsOrderBy>>;
};

/** All input for the create `SchemaMigration` mutation. */
export type CreateSchemaMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SchemaMigration` to be created by this mutation. */
  schemaMigration: SchemaMigrationInput;
};

/** The output of our create `SchemaMigration` mutation. */
export type CreateSchemaMigrationPayload = {
  __typename?: 'CreateSchemaMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigration` that was created by this mutation. */
  schemaMigration?: Maybe<SchemaMigration>;
  /** An edge for our `SchemaMigration`. May be used by Relay 1. */
  schemaMigrationEdge?: Maybe<SchemaMigrationsEdge>;
};


/** The output of our create `SchemaMigration` mutation. */
export type CreateSchemaMigrationPayloadSchemaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};

/** All input for the create `SchemaMigrationsLock` mutation. */
export type CreateSchemaMigrationsLockInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SchemaMigrationsLock` to be created by this mutation. */
  schemaMigrationsLock: SchemaMigrationsLockInput;
};

/** The output of our create `SchemaMigrationsLock` mutation. */
export type CreateSchemaMigrationsLockPayload = {
  __typename?: 'CreateSchemaMigrationsLockPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigrationsLock` that was created by this mutation. */
  schemaMigrationsLock?: Maybe<SchemaMigrationsLock>;
  /** An edge for our `SchemaMigrationsLock`. May be used by Relay 1. */
  schemaMigrationsLockEdge?: Maybe<SchemaMigrationsLocksEdge>;
};


/** The output of our create `SchemaMigrationsLock` mutation. */
export type CreateSchemaMigrationsLockPayloadSchemaMigrationsLockEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsLocksOrderBy>>;
};

/** All input for the create `SellerReview` mutation. */
export type CreateSellerReviewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SellerReview` to be created by this mutation. */
  sellerReview: SellerReviewInput;
};

/** The output of our create `SellerReview` mutation. */
export type CreateSellerReviewPayload = {
  __typename?: 'CreateSellerReviewPayload';
  /** Reads a single `CarsForSale` that is related to this `SellerReview`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SellerReview` that was created by this mutation. */
  sellerReview?: Maybe<SellerReview>;
  /** An edge for our `SellerReview`. May be used by Relay 1. */
  sellerReviewEdge?: Maybe<SellerReviewsEdge>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userBySellerId?: Maybe<User>;
};


/** The output of our create `SellerReview` mutation. */
export type CreateSellerReviewPayloadSellerReviewEdgeArgs = {
  orderBy?: InputMaybe<Array<SellerReviewsOrderBy>>;
};

/** All input for the create `SellerVerification` mutation. */
export type CreateSellerVerificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SellerVerification` to be created by this mutation. */
  sellerVerification: SellerVerificationInput;
};

/** The output of our create `SellerVerification` mutation. */
export type CreateSellerVerificationPayload = {
  __typename?: 'CreateSellerVerificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SellerVerification` that was created by this mutation. */
  sellerVerification?: Maybe<SellerVerification>;
  /** An edge for our `SellerVerification`. May be used by Relay 1. */
  sellerVerificationEdge?: Maybe<SellerVerificationsEdge>;
  /** Reads a single `User` that is related to this `SellerVerification`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `SellerVerification` mutation. */
export type CreateSellerVerificationPayloadSellerVerificationEdgeArgs = {
  orderBy?: InputMaybe<Array<SellerVerificationsOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `VehicleCatalog` mutation. */
export type CreateVehicleCatalogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VehicleCatalog` to be created by this mutation. */
  vehicleCatalog: VehicleCatalogInput;
};

/** The output of our create `VehicleCatalog` mutation. */
export type CreateVehicleCatalogPayload = {
  __typename?: 'CreateVehicleCatalogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VehicleCatalog` that was created by this mutation. */
  vehicleCatalog?: Maybe<VehicleCatalog>;
  /** An edge for our `VehicleCatalog`. May be used by Relay 1. */
  vehicleCatalogEdge?: Maybe<VehicleCatalogsEdge>;
};


/** The output of our create `VehicleCatalog` mutation. */
export type CreateVehicleCatalogPayloadVehicleCatalogEdgeArgs = {
  orderBy?: InputMaybe<Array<VehicleCatalogsOrderBy>>;
};

/** All input for the `deleteCarModelById` mutation. */
export type DeleteCarModelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteCarModel` mutation. */
export type DeleteCarModelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CarModel` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CarModel` mutation. */
export type DeleteCarModelPayload = {
  __typename?: 'DeleteCarModelPayload';
  /** The `CarModel` that was deleted by this mutation. */
  carModel?: Maybe<CarModel>;
  /** An edge for our `CarModel`. May be used by Relay 1. */
  carModelEdge?: Maybe<CarModelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCarModelId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `PopularMake` that is related to this `CarModel`. */
  popularMakeByIdPopularMake?: Maybe<PopularMake>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CarModel` mutation. */
export type DeleteCarModelPayloadCarModelEdgeArgs = {
  orderBy?: InputMaybe<Array<CarModelsOrderBy>>;
};

/** All input for the `deleteCarsForSaleById` mutation. */
export type DeleteCarsForSaleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteCarsForSale` mutation. */
export type DeleteCarsForSaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CarsForSale` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CarsForSale` mutation. */
export type DeleteCarsForSalePayload = {
  __typename?: 'DeleteCarsForSalePayload';
  /** Reads a single `CarModel` that is related to this `CarsForSale`. */
  carModelByIdCarModel?: Maybe<CarModel>;
  /** The `CarsForSale` that was deleted by this mutation. */
  carsForSale?: Maybe<CarsForSale>;
  /** An edge for our `CarsForSale`. May be used by Relay 1. */
  carsForSaleEdge?: Maybe<CarsForSalesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCarsForSaleId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `PopularMake` that is related to this `CarsForSale`. */
  popularMakeByIdCarMake?: Maybe<PopularMake>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySellerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySoldToUserId?: Maybe<User>;
  /** Reads a single `VehicleCatalog` that is related to this `CarsForSale`. */
  vehicleCatalogByCatalogSourceId?: Maybe<VehicleCatalog>;
};


/** The output of our delete `CarsForSale` mutation. */
export type DeleteCarsForSalePayloadCarsForSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};

/** All input for the `deleteConversationById` mutation. */
export type DeleteConversationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteConversationByListingIdAndBuyerIdAndSellerId` mutation. */
export type DeleteConversationByListingIdAndBuyerIdAndSellerIdInput = {
  buyerId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['Int']['input'];
  sellerId: Scalars['Int']['input'];
};

/** All input for the `deleteConversation` mutation. */
export type DeleteConversationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Conversation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Conversation` mutation. */
export type DeleteConversationPayload = {
  __typename?: 'DeleteConversationPayload';
  /** Reads a single `CarsForSale` that is related to this `Conversation`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Conversation` that was deleted by this mutation. */
  conversation?: Maybe<Conversation>;
  /** An edge for our `Conversation`. May be used by Relay 1. */
  conversationEdge?: Maybe<ConversationsEdge>;
  deletedConversationId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userBySellerId?: Maybe<User>;
};


/** The output of our delete `Conversation` mutation. */
export type DeleteConversationPayloadConversationEdgeArgs = {
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};

/** All input for the `deleteEmailVerificationPinById` mutation. */
export type DeleteEmailVerificationPinByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteEmailVerificationPin` mutation. */
export type DeleteEmailVerificationPinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EmailVerificationPin` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `EmailVerificationPin` mutation. */
export type DeleteEmailVerificationPinPayload = {
  __typename?: 'DeleteEmailVerificationPinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedEmailVerificationPinId?: Maybe<Scalars['ID']['output']>;
  /** The `EmailVerificationPin` that was deleted by this mutation. */
  emailVerificationPin?: Maybe<EmailVerificationPin>;
  /** An edge for our `EmailVerificationPin`. May be used by Relay 1. */
  emailVerificationPinEdge?: Maybe<EmailVerificationPinsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailVerificationPin`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `EmailVerificationPin` mutation. */
export type DeleteEmailVerificationPinPayloadEmailVerificationPinEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailVerificationPinsOrderBy>>;
};

/** All input for the `deleteEmailVerificationResendById` mutation. */
export type DeleteEmailVerificationResendByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteEmailVerificationResend` mutation. */
export type DeleteEmailVerificationResendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EmailVerificationResend` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `EmailVerificationResend` mutation. */
export type DeleteEmailVerificationResendPayload = {
  __typename?: 'DeleteEmailVerificationResendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedEmailVerificationResendId?: Maybe<Scalars['ID']['output']>;
  /** The `EmailVerificationResend` that was deleted by this mutation. */
  emailVerificationResend?: Maybe<EmailVerificationResend>;
  /** An edge for our `EmailVerificationResend`. May be used by Relay 1. */
  emailVerificationResendEdge?: Maybe<EmailVerificationResendsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailVerificationResend`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `EmailVerificationResend` mutation. */
export type DeleteEmailVerificationResendPayloadEmailVerificationResendEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailVerificationResendsOrderBy>>;
};

/** All input for the `deletePopularMakeById` mutation. */
export type DeletePopularMakeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deletePopularMake` mutation. */
export type DeletePopularMakeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PopularMake` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PopularMake` mutation. */
export type DeletePopularMakePayload = {
  __typename?: 'DeletePopularMakePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPopularMakeId?: Maybe<Scalars['ID']['output']>;
  /** The `PopularMake` that was deleted by this mutation. */
  popularMake?: Maybe<PopularMake>;
  /** An edge for our `PopularMake`. May be used by Relay 1. */
  popularMakeEdge?: Maybe<PopularMakesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PopularMake` mutation. */
export type DeletePopularMakePayloadPopularMakeEdgeArgs = {
  orderBy?: InputMaybe<Array<PopularMakesOrderBy>>;
};

/** All input for the `deletePrivateMessageById` mutation. */
export type DeletePrivateMessageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deletePrivateMessage` mutation. */
export type DeletePrivateMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PrivateMessage` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PrivateMessage` mutation. */
export type DeletePrivateMessagePayload = {
  __typename?: 'DeletePrivateMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Conversation` that is related to this `PrivateMessage`. */
  conversationByConversationId?: Maybe<Conversation>;
  deletedPrivateMessageId?: Maybe<Scalars['ID']['output']>;
  /** The `PrivateMessage` that was deleted by this mutation. */
  privateMessage?: Maybe<PrivateMessage>;
  /** An edge for our `PrivateMessage`. May be used by Relay 1. */
  privateMessageEdge?: Maybe<PrivateMessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PrivateMessage`. */
  userBySenderId?: Maybe<User>;
};


/** The output of our delete `PrivateMessage` mutation. */
export type DeletePrivateMessagePayloadPrivateMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<PrivateMessagesOrderBy>>;
};

/** All input for the `deletePublicCommentById` mutation. */
export type DeletePublicCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deletePublicComment` mutation. */
export type DeletePublicCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PublicComment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PublicComment` mutation. */
export type DeletePublicCommentPayload = {
  __typename?: 'DeletePublicCommentPayload';
  /** Reads a single `CarsForSale` that is related to this `PublicComment`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPublicCommentId?: Maybe<Scalars['ID']['output']>;
  /** The `PublicComment` that was deleted by this mutation. */
  publicComment?: Maybe<PublicComment>;
  /** Reads a single `PublicComment` that is related to this `PublicComment`. */
  publicCommentByParentCommentId?: Maybe<PublicComment>;
  /** An edge for our `PublicComment`. May be used by Relay 1. */
  publicCommentEdge?: Maybe<PublicCommentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PublicComment`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `PublicComment` mutation. */
export type DeletePublicCommentPayloadPublicCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PublicCommentsOrderBy>>;
};

/** All input for the `deleteSchemaMigrationById` mutation. */
export type DeleteSchemaMigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteSchemaMigration` mutation. */
export type DeleteSchemaMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaMigration` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SchemaMigration` mutation. */
export type DeleteSchemaMigrationPayload = {
  __typename?: 'DeleteSchemaMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSchemaMigrationId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigration` that was deleted by this mutation. */
  schemaMigration?: Maybe<SchemaMigration>;
  /** An edge for our `SchemaMigration`. May be used by Relay 1. */
  schemaMigrationEdge?: Maybe<SchemaMigrationsEdge>;
};


/** The output of our delete `SchemaMigration` mutation. */
export type DeleteSchemaMigrationPayloadSchemaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};

/** All input for the `deleteSchemaMigrationsLockByIndex` mutation. */
export type DeleteSchemaMigrationsLockByIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
};

/** All input for the `deleteSchemaMigrationsLock` mutation. */
export type DeleteSchemaMigrationsLockInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaMigrationsLock` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SchemaMigrationsLock` mutation. */
export type DeleteSchemaMigrationsLockPayload = {
  __typename?: 'DeleteSchemaMigrationsLockPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSchemaMigrationsLockId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigrationsLock` that was deleted by this mutation. */
  schemaMigrationsLock?: Maybe<SchemaMigrationsLock>;
  /** An edge for our `SchemaMigrationsLock`. May be used by Relay 1. */
  schemaMigrationsLockEdge?: Maybe<SchemaMigrationsLocksEdge>;
};


/** The output of our delete `SchemaMigrationsLock` mutation. */
export type DeleteSchemaMigrationsLockPayloadSchemaMigrationsLockEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsLocksOrderBy>>;
};

/** All input for the `deleteSellerReviewByBuyerIdAndListingId` mutation. */
export type DeleteSellerReviewByBuyerIdAndListingIdInput = {
  buyerId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['Int']['input'];
};

/** All input for the `deleteSellerReviewById` mutation. */
export type DeleteSellerReviewByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteSellerReview` mutation. */
export type DeleteSellerReviewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SellerReview` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SellerReview` mutation. */
export type DeleteSellerReviewPayload = {
  __typename?: 'DeleteSellerReviewPayload';
  /** Reads a single `CarsForSale` that is related to this `SellerReview`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSellerReviewId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SellerReview` that was deleted by this mutation. */
  sellerReview?: Maybe<SellerReview>;
  /** An edge for our `SellerReview`. May be used by Relay 1. */
  sellerReviewEdge?: Maybe<SellerReviewsEdge>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userBySellerId?: Maybe<User>;
};


/** The output of our delete `SellerReview` mutation. */
export type DeleteSellerReviewPayloadSellerReviewEdgeArgs = {
  orderBy?: InputMaybe<Array<SellerReviewsOrderBy>>;
};

/** All input for the `deleteSellerVerificationById` mutation. */
export type DeleteSellerVerificationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteSellerVerificationByUserIdAndVerificationType` mutation. */
export type DeleteSellerVerificationByUserIdAndVerificationTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  verificationType: Scalars['String']['input'];
};

/** All input for the `deleteSellerVerification` mutation. */
export type DeleteSellerVerificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SellerVerification` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SellerVerification` mutation. */
export type DeleteSellerVerificationPayload = {
  __typename?: 'DeleteSellerVerificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSellerVerificationId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SellerVerification` that was deleted by this mutation. */
  sellerVerification?: Maybe<SellerVerification>;
  /** An edge for our `SellerVerification`. May be used by Relay 1. */
  sellerVerificationEdge?: Maybe<SellerVerificationsEdge>;
  /** Reads a single `User` that is related to this `SellerVerification`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `SellerVerification` mutation. */
export type DeleteSellerVerificationPayloadSellerVerificationEdgeArgs = {
  orderBy?: InputMaybe<Array<SellerVerificationsOrderBy>>;
};

/** All input for the `deleteUserByEmail` mutation. */
export type DeleteUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** All input for the `deleteUserById` mutation. */
export type DeleteUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `deleteUserByPhoneNumber` mutation. */
export type DeleteUserByPhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteVehicleCatalogBySourceId` mutation. */
export type DeleteVehicleCatalogBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
};

/** All input for the `deleteVehicleCatalog` mutation. */
export type DeleteVehicleCatalogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VehicleCatalog` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VehicleCatalog` mutation. */
export type DeleteVehicleCatalogPayload = {
  __typename?: 'DeleteVehicleCatalogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVehicleCatalogId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VehicleCatalog` that was deleted by this mutation. */
  vehicleCatalog?: Maybe<VehicleCatalog>;
  /** An edge for our `VehicleCatalog`. May be used by Relay 1. */
  vehicleCatalogEdge?: Maybe<VehicleCatalogsEdge>;
};


/** The output of our delete `VehicleCatalog` mutation. */
export type DeleteVehicleCatalogPayloadVehicleCatalogEdgeArgs = {
  orderBy?: InputMaybe<Array<VehicleCatalogsOrderBy>>;
};

export type EmailVerificationPin = Node & {
  __typename?: 'EmailVerificationPin';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  expiresAt: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  magicToken?: Maybe<Scalars['String']['output']>;
  magicTokenUsedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  pin: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `EmailVerificationPin`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `EmailVerificationPin` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EmailVerificationPinCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `magicToken` field. */
  magicToken?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `magicTokenUsedAt` field. */
  magicTokenUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `pin` field. */
  pin?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `EmailVerificationPin` */
export type EmailVerificationPinInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt: Scalars['Datetime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  magicToken?: InputMaybe<Scalars['String']['input']>;
  magicTokenUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  pin: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

/** Represents an update to a `EmailVerificationPin`. Fields that are set will be updated. */
export type EmailVerificationPinPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  magicToken?: InputMaybe<Scalars['String']['input']>;
  magicTokenUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `EmailVerificationPin` values. */
export type EmailVerificationPinsConnection = {
  __typename?: 'EmailVerificationPinsConnection';
  /** A list of edges which contains the `EmailVerificationPin` and cursor to aid in pagination. */
  edges: Array<EmailVerificationPinsEdge>;
  /** A list of `EmailVerificationPin` objects. */
  nodes: Array<Maybe<EmailVerificationPin>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailVerificationPin` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmailVerificationPin` edge in the connection. */
export type EmailVerificationPinsEdge = {
  __typename?: 'EmailVerificationPinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailVerificationPin` at the end of the edge. */
  node?: Maybe<EmailVerificationPin>;
};

/** Methods to use when ordering `EmailVerificationPin`. */
export enum EmailVerificationPinsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MagicTokenAsc = 'MAGIC_TOKEN_ASC',
  MagicTokenDesc = 'MAGIC_TOKEN_DESC',
  MagicTokenUsedAtAsc = 'MAGIC_TOKEN_USED_AT_ASC',
  MagicTokenUsedAtDesc = 'MAGIC_TOKEN_USED_AT_DESC',
  Natural = 'NATURAL',
  PinAsc = 'PIN_ASC',
  PinDesc = 'PIN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type EmailVerificationResend = Node & {
  __typename?: 'EmailVerificationResend';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `EmailVerificationResend`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `EmailVerificationResend` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EmailVerificationResendCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `EmailVerificationResend` */
export type EmailVerificationResendInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Represents an update to a `EmailVerificationResend`. Fields that are set will be updated. */
export type EmailVerificationResendPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `EmailVerificationResend` values. */
export type EmailVerificationResendsConnection = {
  __typename?: 'EmailVerificationResendsConnection';
  /** A list of edges which contains the `EmailVerificationResend` and cursor to aid in pagination. */
  edges: Array<EmailVerificationResendsEdge>;
  /** A list of `EmailVerificationResend` objects. */
  nodes: Array<Maybe<EmailVerificationResend>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailVerificationResend` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmailVerificationResend` edge in the connection. */
export type EmailVerificationResendsEdge = {
  __typename?: 'EmailVerificationResendsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailVerificationResend` at the end of the edge. */
  node?: Maybe<EmailVerificationResend>;
};

/** Methods to use when ordering `EmailVerificationResend`. */
export enum EmailVerificationResendsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a single `CarModel`. */
  createCarModel?: Maybe<CreateCarModelPayload>;
  /** Creates a single `CarsForSale`. */
  createCarsForSale?: Maybe<CreateCarsForSalePayload>;
  /** Creates a single `Conversation`. */
  createConversation?: Maybe<CreateConversationPayload>;
  /** Creates a single `EmailVerificationPin`. */
  createEmailVerificationPin?: Maybe<CreateEmailVerificationPinPayload>;
  /** Creates a single `EmailVerificationResend`. */
  createEmailVerificationResend?: Maybe<CreateEmailVerificationResendPayload>;
  /** Creates a single `PopularMake`. */
  createPopularMake?: Maybe<CreatePopularMakePayload>;
  /** Creates a single `PrivateMessage`. */
  createPrivateMessage?: Maybe<CreatePrivateMessagePayload>;
  /** Creates a single `PublicComment`. */
  createPublicComment?: Maybe<CreatePublicCommentPayload>;
  /** Creates a single `SchemaMigration`. */
  createSchemaMigration?: Maybe<CreateSchemaMigrationPayload>;
  /** Creates a single `SchemaMigrationsLock`. */
  createSchemaMigrationsLock?: Maybe<CreateSchemaMigrationsLockPayload>;
  /** Creates a single `SellerReview`. */
  createSellerReview?: Maybe<CreateSellerReviewPayload>;
  /** Creates a single `SellerVerification`. */
  createSellerVerification?: Maybe<CreateSellerVerificationPayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `VehicleCatalog`. */
  createVehicleCatalog?: Maybe<CreateVehicleCatalogPayload>;
  /** Deletes a single `CarModel` using its globally unique id. */
  deleteCarModel?: Maybe<DeleteCarModelPayload>;
  /** Deletes a single `CarModel` using a unique key. */
  deleteCarModelById?: Maybe<DeleteCarModelPayload>;
  /** Deletes a single `CarsForSale` using its globally unique id. */
  deleteCarsForSale?: Maybe<DeleteCarsForSalePayload>;
  /** Deletes a single `CarsForSale` using a unique key. */
  deleteCarsForSaleById?: Maybe<DeleteCarsForSalePayload>;
  /** Deletes a single `Conversation` using its globally unique id. */
  deleteConversation?: Maybe<DeleteConversationPayload>;
  /** Deletes a single `Conversation` using a unique key. */
  deleteConversationById?: Maybe<DeleteConversationPayload>;
  /** Deletes a single `Conversation` using a unique key. */
  deleteConversationByListingIdAndBuyerIdAndSellerId?: Maybe<DeleteConversationPayload>;
  /** Deletes a single `EmailVerificationPin` using its globally unique id. */
  deleteEmailVerificationPin?: Maybe<DeleteEmailVerificationPinPayload>;
  /** Deletes a single `EmailVerificationPin` using a unique key. */
  deleteEmailVerificationPinById?: Maybe<DeleteEmailVerificationPinPayload>;
  /** Deletes a single `EmailVerificationResend` using its globally unique id. */
  deleteEmailVerificationResend?: Maybe<DeleteEmailVerificationResendPayload>;
  /** Deletes a single `EmailVerificationResend` using a unique key. */
  deleteEmailVerificationResendById?: Maybe<DeleteEmailVerificationResendPayload>;
  /** Deletes a single `PopularMake` using its globally unique id. */
  deletePopularMake?: Maybe<DeletePopularMakePayload>;
  /** Deletes a single `PopularMake` using a unique key. */
  deletePopularMakeById?: Maybe<DeletePopularMakePayload>;
  /** Deletes a single `PrivateMessage` using its globally unique id. */
  deletePrivateMessage?: Maybe<DeletePrivateMessagePayload>;
  /** Deletes a single `PrivateMessage` using a unique key. */
  deletePrivateMessageById?: Maybe<DeletePrivateMessagePayload>;
  /** Deletes a single `PublicComment` using its globally unique id. */
  deletePublicComment?: Maybe<DeletePublicCommentPayload>;
  /** Deletes a single `PublicComment` using a unique key. */
  deletePublicCommentById?: Maybe<DeletePublicCommentPayload>;
  /** Deletes a single `SchemaMigration` using its globally unique id. */
  deleteSchemaMigration?: Maybe<DeleteSchemaMigrationPayload>;
  /** Deletes a single `SchemaMigration` using a unique key. */
  deleteSchemaMigrationById?: Maybe<DeleteSchemaMigrationPayload>;
  /** Deletes a single `SchemaMigrationsLock` using its globally unique id. */
  deleteSchemaMigrationsLock?: Maybe<DeleteSchemaMigrationsLockPayload>;
  /** Deletes a single `SchemaMigrationsLock` using a unique key. */
  deleteSchemaMigrationsLockByIndex?: Maybe<DeleteSchemaMigrationsLockPayload>;
  /** Deletes a single `SellerReview` using its globally unique id. */
  deleteSellerReview?: Maybe<DeleteSellerReviewPayload>;
  /** Deletes a single `SellerReview` using a unique key. */
  deleteSellerReviewByBuyerIdAndListingId?: Maybe<DeleteSellerReviewPayload>;
  /** Deletes a single `SellerReview` using a unique key. */
  deleteSellerReviewById?: Maybe<DeleteSellerReviewPayload>;
  /** Deletes a single `SellerVerification` using its globally unique id. */
  deleteSellerVerification?: Maybe<DeleteSellerVerificationPayload>;
  /** Deletes a single `SellerVerification` using a unique key. */
  deleteSellerVerificationById?: Maybe<DeleteSellerVerificationPayload>;
  /** Deletes a single `SellerVerification` using a unique key. */
  deleteSellerVerificationByUserIdAndVerificationType?: Maybe<DeleteSellerVerificationPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByEmail?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserById?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByPhoneNumber?: Maybe<DeleteUserPayload>;
  /** Deletes a single `VehicleCatalog` using its globally unique id. */
  deleteVehicleCatalog?: Maybe<DeleteVehicleCatalogPayload>;
  /** Deletes a single `VehicleCatalog` using a unique key. */
  deleteVehicleCatalogBySourceId?: Maybe<DeleteVehicleCatalogPayload>;
  /** Updates a single `CarModel` using its globally unique id and a patch. */
  updateCarModel?: Maybe<UpdateCarModelPayload>;
  /** Updates a single `CarModel` using a unique key and a patch. */
  updateCarModelById?: Maybe<UpdateCarModelPayload>;
  /** Updates a single `CarsForSale` using its globally unique id and a patch. */
  updateCarsForSale?: Maybe<UpdateCarsForSalePayload>;
  /** Updates a single `CarsForSale` using a unique key and a patch. */
  updateCarsForSaleById?: Maybe<UpdateCarsForSalePayload>;
  /** Updates a single `Conversation` using its globally unique id and a patch. */
  updateConversation?: Maybe<UpdateConversationPayload>;
  /** Updates a single `Conversation` using a unique key and a patch. */
  updateConversationById?: Maybe<UpdateConversationPayload>;
  /** Updates a single `Conversation` using a unique key and a patch. */
  updateConversationByListingIdAndBuyerIdAndSellerId?: Maybe<UpdateConversationPayload>;
  /** Updates a single `EmailVerificationPin` using its globally unique id and a patch. */
  updateEmailVerificationPin?: Maybe<UpdateEmailVerificationPinPayload>;
  /** Updates a single `EmailVerificationPin` using a unique key and a patch. */
  updateEmailVerificationPinById?: Maybe<UpdateEmailVerificationPinPayload>;
  /** Updates a single `EmailVerificationResend` using its globally unique id and a patch. */
  updateEmailVerificationResend?: Maybe<UpdateEmailVerificationResendPayload>;
  /** Updates a single `EmailVerificationResend` using a unique key and a patch. */
  updateEmailVerificationResendById?: Maybe<UpdateEmailVerificationResendPayload>;
  /** Updates a single `PopularMake` using its globally unique id and a patch. */
  updatePopularMake?: Maybe<UpdatePopularMakePayload>;
  /** Updates a single `PopularMake` using a unique key and a patch. */
  updatePopularMakeById?: Maybe<UpdatePopularMakePayload>;
  /** Updates a single `PrivateMessage` using its globally unique id and a patch. */
  updatePrivateMessage?: Maybe<UpdatePrivateMessagePayload>;
  /** Updates a single `PrivateMessage` using a unique key and a patch. */
  updatePrivateMessageById?: Maybe<UpdatePrivateMessagePayload>;
  /** Updates a single `PublicComment` using its globally unique id and a patch. */
  updatePublicComment?: Maybe<UpdatePublicCommentPayload>;
  /** Updates a single `PublicComment` using a unique key and a patch. */
  updatePublicCommentById?: Maybe<UpdatePublicCommentPayload>;
  /** Updates a single `SchemaMigration` using its globally unique id and a patch. */
  updateSchemaMigration?: Maybe<UpdateSchemaMigrationPayload>;
  /** Updates a single `SchemaMigration` using a unique key and a patch. */
  updateSchemaMigrationById?: Maybe<UpdateSchemaMigrationPayload>;
  /** Updates a single `SchemaMigrationsLock` using its globally unique id and a patch. */
  updateSchemaMigrationsLock?: Maybe<UpdateSchemaMigrationsLockPayload>;
  /** Updates a single `SchemaMigrationsLock` using a unique key and a patch. */
  updateSchemaMigrationsLockByIndex?: Maybe<UpdateSchemaMigrationsLockPayload>;
  /** Updates a single `SellerReview` using its globally unique id and a patch. */
  updateSellerReview?: Maybe<UpdateSellerReviewPayload>;
  /** Updates a single `SellerReview` using a unique key and a patch. */
  updateSellerReviewByBuyerIdAndListingId?: Maybe<UpdateSellerReviewPayload>;
  /** Updates a single `SellerReview` using a unique key and a patch. */
  updateSellerReviewById?: Maybe<UpdateSellerReviewPayload>;
  /** Updates a single `SellerVerification` using its globally unique id and a patch. */
  updateSellerVerification?: Maybe<UpdateSellerVerificationPayload>;
  /** Updates a single `SellerVerification` using a unique key and a patch. */
  updateSellerVerificationById?: Maybe<UpdateSellerVerificationPayload>;
  /** Updates a single `SellerVerification` using a unique key and a patch. */
  updateSellerVerificationByUserIdAndVerificationType?: Maybe<UpdateSellerVerificationPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByEmail?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserById?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByPhoneNumber?: Maybe<UpdateUserPayload>;
  /** Updates a single `VehicleCatalog` using its globally unique id and a patch. */
  updateVehicleCatalog?: Maybe<UpdateVehicleCatalogPayload>;
  /** Updates a single `VehicleCatalog` using a unique key and a patch. */
  updateVehicleCatalogBySourceId?: Maybe<UpdateVehicleCatalogPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCarModelArgs = {
  input: CreateCarModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCarsForSaleArgs = {
  input: CreateCarsForSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailVerificationPinArgs = {
  input: CreateEmailVerificationPinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailVerificationResendArgs = {
  input: CreateEmailVerificationResendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePopularMakeArgs = {
  input: CreatePopularMakeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePrivateMessageArgs = {
  input: CreatePrivateMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePublicCommentArgs = {
  input: CreatePublicCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSchemaMigrationArgs = {
  input: CreateSchemaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSchemaMigrationsLockArgs = {
  input: CreateSchemaMigrationsLockInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSellerReviewArgs = {
  input: CreateSellerReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSellerVerificationArgs = {
  input: CreateSellerVerificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVehicleCatalogArgs = {
  input: CreateVehicleCatalogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCarModelArgs = {
  input: DeleteCarModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCarModelByIdArgs = {
  input: DeleteCarModelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCarsForSaleArgs = {
  input: DeleteCarsForSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCarsForSaleByIdArgs = {
  input: DeleteCarsForSaleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConversationArgs = {
  input: DeleteConversationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConversationByIdArgs = {
  input: DeleteConversationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConversationByListingIdAndBuyerIdAndSellerIdArgs = {
  input: DeleteConversationByListingIdAndBuyerIdAndSellerIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailVerificationPinArgs = {
  input: DeleteEmailVerificationPinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailVerificationPinByIdArgs = {
  input: DeleteEmailVerificationPinByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailVerificationResendArgs = {
  input: DeleteEmailVerificationResendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailVerificationResendByIdArgs = {
  input: DeleteEmailVerificationResendByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePopularMakeArgs = {
  input: DeletePopularMakeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePopularMakeByIdArgs = {
  input: DeletePopularMakeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePrivateMessageArgs = {
  input: DeletePrivateMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePrivateMessageByIdArgs = {
  input: DeletePrivateMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePublicCommentArgs = {
  input: DeletePublicCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePublicCommentByIdArgs = {
  input: DeletePublicCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaMigrationArgs = {
  input: DeleteSchemaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaMigrationByIdArgs = {
  input: DeleteSchemaMigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaMigrationsLockArgs = {
  input: DeleteSchemaMigrationsLockInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaMigrationsLockByIndexArgs = {
  input: DeleteSchemaMigrationsLockByIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSellerReviewArgs = {
  input: DeleteSellerReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSellerReviewByBuyerIdAndListingIdArgs = {
  input: DeleteSellerReviewByBuyerIdAndListingIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSellerReviewByIdArgs = {
  input: DeleteSellerReviewByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSellerVerificationArgs = {
  input: DeleteSellerVerificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSellerVerificationByIdArgs = {
  input: DeleteSellerVerificationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSellerVerificationByUserIdAndVerificationTypeArgs = {
  input: DeleteSellerVerificationByUserIdAndVerificationTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByEmailArgs = {
  input: DeleteUserByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByIdArgs = {
  input: DeleteUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByPhoneNumberArgs = {
  input: DeleteUserByPhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVehicleCatalogArgs = {
  input: DeleteVehicleCatalogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVehicleCatalogBySourceIdArgs = {
  input: DeleteVehicleCatalogBySourceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCarModelArgs = {
  input: UpdateCarModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCarModelByIdArgs = {
  input: UpdateCarModelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCarsForSaleArgs = {
  input: UpdateCarsForSaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCarsForSaleByIdArgs = {
  input: UpdateCarsForSaleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConversationArgs = {
  input: UpdateConversationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConversationByIdArgs = {
  input: UpdateConversationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConversationByListingIdAndBuyerIdAndSellerIdArgs = {
  input: UpdateConversationByListingIdAndBuyerIdAndSellerIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailVerificationPinArgs = {
  input: UpdateEmailVerificationPinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailVerificationPinByIdArgs = {
  input: UpdateEmailVerificationPinByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailVerificationResendArgs = {
  input: UpdateEmailVerificationResendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailVerificationResendByIdArgs = {
  input: UpdateEmailVerificationResendByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePopularMakeArgs = {
  input: UpdatePopularMakeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePopularMakeByIdArgs = {
  input: UpdatePopularMakeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePrivateMessageArgs = {
  input: UpdatePrivateMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePrivateMessageByIdArgs = {
  input: UpdatePrivateMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePublicCommentArgs = {
  input: UpdatePublicCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePublicCommentByIdArgs = {
  input: UpdatePublicCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaMigrationArgs = {
  input: UpdateSchemaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaMigrationByIdArgs = {
  input: UpdateSchemaMigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaMigrationsLockArgs = {
  input: UpdateSchemaMigrationsLockInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaMigrationsLockByIndexArgs = {
  input: UpdateSchemaMigrationsLockByIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSellerReviewArgs = {
  input: UpdateSellerReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSellerReviewByBuyerIdAndListingIdArgs = {
  input: UpdateSellerReviewByBuyerIdAndListingIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSellerReviewByIdArgs = {
  input: UpdateSellerReviewByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSellerVerificationArgs = {
  input: UpdateSellerVerificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSellerVerificationByIdArgs = {
  input: UpdateSellerVerificationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSellerVerificationByUserIdAndVerificationTypeArgs = {
  input: UpdateSellerVerificationByUserIdAndVerificationTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByEmailArgs = {
  input: UpdateUserByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByPhoneNumberArgs = {
  input: UpdateUserByPhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVehicleCatalogArgs = {
  input: UpdateVehicleCatalogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVehicleCatalogBySourceIdArgs = {
  input: UpdateVehicleCatalogBySourceIdInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PopularMake = Node & {
  __typename?: 'PopularMake';
  /** Reads and enables pagination through a set of `CarModel`. */
  carModelsByIdPopularMake: CarModelsConnection;
  /** Reads and enables pagination through a set of `CarsForSale`. */
  carsForSalesByIdCarMake: CarsForSalesConnection;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type PopularMakeCarModelsByIdPopularMakeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarModelCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarModelsOrderBy>>;
};


export type PopularMakeCarsForSalesByIdCarMakeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarsForSaleCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};

/**
 * A condition to be used against `PopularMake` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PopularMakeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An input for mutations affecting `PopularMake` */
export type PopularMakeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Represents an update to a `PopularMake`. Fields that are set will be updated. */
export type PopularMakePatch = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `PopularMake` values. */
export type PopularMakesConnection = {
  __typename?: 'PopularMakesConnection';
  /** A list of edges which contains the `PopularMake` and cursor to aid in pagination. */
  edges: Array<PopularMakesEdge>;
  /** A list of `PopularMake` objects. */
  nodes: Array<Maybe<PopularMake>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PopularMake` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PopularMake` edge in the connection. */
export type PopularMakesEdge = {
  __typename?: 'PopularMakesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PopularMake` at the end of the edge. */
  node?: Maybe<PopularMake>;
};

/** Methods to use when ordering `PopularMake`. */
export enum PopularMakesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type PrivateMessage = Node & {
  __typename?: 'PrivateMessage';
  content: Scalars['String']['output'];
  /** Reads a single `Conversation` that is related to this `PrivateMessage`. */
  conversationByConversationId?: Maybe<Conversation>;
  conversationId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  senderId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `PrivateMessage`. */
  userBySenderId?: Maybe<User>;
};

/**
 * A condition to be used against `PrivateMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PrivateMessageCondition = {
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `conversationId` field. */
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `readAt` field. */
  readAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `senderId` field. */
  senderId?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `PrivateMessage` */
export type PrivateMessageInput = {
  content: Scalars['String']['input'];
  conversationId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  readAt?: InputMaybe<Scalars['Datetime']['input']>;
  senderId: Scalars['Int']['input'];
};

/** Represents an update to a `PrivateMessage`. Fields that are set will be updated. */
export type PrivateMessagePatch = {
  content?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  readAt?: InputMaybe<Scalars['Datetime']['input']>;
  senderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PrivateMessage` values. */
export type PrivateMessagesConnection = {
  __typename?: 'PrivateMessagesConnection';
  /** A list of edges which contains the `PrivateMessage` and cursor to aid in pagination. */
  edges: Array<PrivateMessagesEdge>;
  /** A list of `PrivateMessage` objects. */
  nodes: Array<Maybe<PrivateMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PrivateMessage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PrivateMessage` edge in the connection. */
export type PrivateMessagesEdge = {
  __typename?: 'PrivateMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PrivateMessage` at the end of the edge. */
  node?: Maybe<PrivateMessage>;
};

/** Methods to use when ordering `PrivateMessage`. */
export enum PrivateMessagesOrderBy {
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  ConversationIdAsc = 'CONVERSATION_ID_ASC',
  ConversationIdDesc = 'CONVERSATION_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReadAtAsc = 'READ_AT_ASC',
  ReadAtDesc = 'READ_AT_DESC',
  SenderIdAsc = 'SENDER_ID_ASC',
  SenderIdDesc = 'SENDER_ID_DESC'
}

export type PublicComment = Node & {
  __typename?: 'PublicComment';
  /** Reads a single `CarsForSale` that is related to this `PublicComment`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  parentCommentId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `PublicComment` that is related to this `PublicComment`. */
  publicCommentByParentCommentId?: Maybe<PublicComment>;
  /** Reads and enables pagination through a set of `PublicComment`. */
  publicCommentsByParentCommentId: PublicCommentsConnection;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `PublicComment`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type PublicCommentPublicCommentsByParentCommentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PublicCommentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublicCommentsOrderBy>>;
};

/**
 * A condition to be used against `PublicComment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PublicCommentCondition = {
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `listingId` field. */
  listingId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `parentCommentId` field. */
  parentCommentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `PublicComment` */
export type PublicCommentInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listingId: Scalars['Int']['input'];
  parentCommentId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['Int']['input'];
};

/** Represents an update to a `PublicComment`. Fields that are set will be updated. */
export type PublicCommentPatch = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listingId?: InputMaybe<Scalars['Int']['input']>;
  parentCommentId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PublicComment` values. */
export type PublicCommentsConnection = {
  __typename?: 'PublicCommentsConnection';
  /** A list of edges which contains the `PublicComment` and cursor to aid in pagination. */
  edges: Array<PublicCommentsEdge>;
  /** A list of `PublicComment` objects. */
  nodes: Array<Maybe<PublicComment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PublicComment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PublicComment` edge in the connection. */
export type PublicCommentsEdge = {
  __typename?: 'PublicCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PublicComment` at the end of the edge. */
  node?: Maybe<PublicComment>;
};

/** Methods to use when ordering `PublicComment`. */
export enum PublicCommentsOrderBy {
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ListingIdAsc = 'LISTING_ID_ASC',
  ListingIdDesc = 'LISTING_ID_DESC',
  Natural = 'NATURAL',
  ParentCommentIdAsc = 'PARENT_COMMENT_ID_ASC',
  ParentCommentIdDesc = 'PARENT_COMMENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads and enables pagination through a set of `CarModel`. */
  allCarModels?: Maybe<CarModelsConnection>;
  /** Reads and enables pagination through a set of `CarsForSale`. */
  allCarsForSales?: Maybe<CarsForSalesConnection>;
  /** Reads and enables pagination through a set of `Conversation`. */
  allConversations?: Maybe<ConversationsConnection>;
  /** Reads and enables pagination through a set of `EmailVerificationPin`. */
  allEmailVerificationPins?: Maybe<EmailVerificationPinsConnection>;
  /** Reads and enables pagination through a set of `EmailVerificationResend`. */
  allEmailVerificationResends?: Maybe<EmailVerificationResendsConnection>;
  /** Reads and enables pagination through a set of `PopularMake`. */
  allPopularMakes?: Maybe<PopularMakesConnection>;
  /** Reads and enables pagination through a set of `PrivateMessage`. */
  allPrivateMessages?: Maybe<PrivateMessagesConnection>;
  /** Reads and enables pagination through a set of `PublicComment`. */
  allPublicComments?: Maybe<PublicCommentsConnection>;
  /** Reads and enables pagination through a set of `SchemaMigration`. */
  allSchemaMigrations?: Maybe<SchemaMigrationsConnection>;
  /** Reads and enables pagination through a set of `SchemaMigrationsLock`. */
  allSchemaMigrationsLocks?: Maybe<SchemaMigrationsLocksConnection>;
  /** Reads and enables pagination through a set of `SellerReview`. */
  allSellerReviews?: Maybe<SellerReviewsConnection>;
  /** Reads and enables pagination through a set of `SellerVerification`. */
  allSellerVerifications?: Maybe<SellerVerificationsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  allUsers?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `VehicleCatalogMakeModel`. */
  allVehicleCatalogMakeModels?: Maybe<VehicleCatalogMakeModelsConnection>;
  /** Reads and enables pagination through a set of `VehicleCatalog`. */
  allVehicleCatalogs?: Maybe<VehicleCatalogsConnection>;
  /** Reads a single `CarModel` using its globally unique `ID`. */
  carModel?: Maybe<CarModel>;
  carModelById?: Maybe<CarModel>;
  /** Reads a single `CarsForSale` using its globally unique `ID`. */
  carsForSale?: Maybe<CarsForSale>;
  carsForSaleById?: Maybe<CarsForSale>;
  /** Reads a single `Conversation` using its globally unique `ID`. */
  conversation?: Maybe<Conversation>;
  conversationById?: Maybe<Conversation>;
  conversationByListingIdAndBuyerIdAndSellerId?: Maybe<Conversation>;
  /** Reads a single `EmailVerificationPin` using its globally unique `ID`. */
  emailVerificationPin?: Maybe<EmailVerificationPin>;
  emailVerificationPinById?: Maybe<EmailVerificationPin>;
  /** Reads a single `EmailVerificationResend` using its globally unique `ID`. */
  emailVerificationResend?: Maybe<EmailVerificationResend>;
  emailVerificationResendById?: Maybe<EmailVerificationResend>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `PopularMake` using its globally unique `ID`. */
  popularMake?: Maybe<PopularMake>;
  popularMakeById?: Maybe<PopularMake>;
  /** Reads a single `PrivateMessage` using its globally unique `ID`. */
  privateMessage?: Maybe<PrivateMessage>;
  privateMessageById?: Maybe<PrivateMessage>;
  /** Reads a single `PublicComment` using its globally unique `ID`. */
  publicComment?: Maybe<PublicComment>;
  publicCommentById?: Maybe<PublicComment>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `SchemaMigration` using its globally unique `ID`. */
  schemaMigration?: Maybe<SchemaMigration>;
  schemaMigrationById?: Maybe<SchemaMigration>;
  /** Reads a single `SchemaMigrationsLock` using its globally unique `ID`. */
  schemaMigrationsLock?: Maybe<SchemaMigrationsLock>;
  schemaMigrationsLockByIndex?: Maybe<SchemaMigrationsLock>;
  /** Reads a single `SellerReview` using its globally unique `ID`. */
  sellerReview?: Maybe<SellerReview>;
  sellerReviewByBuyerIdAndListingId?: Maybe<SellerReview>;
  sellerReviewById?: Maybe<SellerReview>;
  /** Reads a single `SellerVerification` using its globally unique `ID`. */
  sellerVerification?: Maybe<SellerVerification>;
  sellerVerificationById?: Maybe<SellerVerification>;
  sellerVerificationByUserIdAndVerificationType?: Maybe<SellerVerification>;
  /** Reads a single `User` using its globally unique `ID`. */
  user?: Maybe<User>;
  userByEmail?: Maybe<User>;
  userById?: Maybe<User>;
  userByPhoneNumber?: Maybe<User>;
  /** Reads a single `VehicleCatalog` using its globally unique `ID`. */
  vehicleCatalog?: Maybe<VehicleCatalog>;
  vehicleCatalogBySourceId?: Maybe<VehicleCatalog>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCarModelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarModelCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarModelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCarsForSalesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarsForSaleCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConversationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEmailVerificationPinsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailVerificationPinCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailVerificationPinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEmailVerificationResendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailVerificationResendCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailVerificationResendsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPopularMakesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PopularMakeCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PopularMakesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrivateMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PrivateMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PrivateMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPublicCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PublicCommentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublicCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSchemaMigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaMigrationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSchemaMigrationsLocksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaMigrationsLockCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaMigrationsLocksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSellerReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SellerReviewCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SellerReviewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSellerVerificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SellerVerificationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SellerVerificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVehicleCatalogMakeModelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VehicleCatalogMakeModelCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VehicleCatalogMakeModelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVehicleCatalogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VehicleCatalogCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VehicleCatalogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCarModelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCarModelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCarsForSaleArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCarsForSaleByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConversationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConversationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConversationByListingIdAndBuyerIdAndSellerIdArgs = {
  buyerId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
  sellerId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailVerificationPinArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailVerificationPinByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailVerificationResendArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailVerificationResendByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPopularMakeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPopularMakeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPrivateMessageArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPrivateMessageByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPublicCommentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPublicCommentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaMigrationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaMigrationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaMigrationsLockArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaMigrationsLockByIndexArgs = {
  index: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySellerReviewArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySellerReviewByBuyerIdAndListingIdArgs = {
  buyerId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySellerReviewByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySellerVerificationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySellerVerificationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySellerVerificationByUserIdAndVerificationTypeArgs = {
  userId: Scalars['Int']['input'];
  verificationType: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVehicleCatalogArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVehicleCatalogBySourceIdArgs = {
  sourceId: Scalars['String']['input'];
};

export type SchemaMigration = Node & {
  __typename?: 'SchemaMigration';
  batch?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  migrationTime?: Maybe<Scalars['Datetime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `SchemaMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SchemaMigrationCondition = {
  /** Checks for equality with the object’s `batch` field. */
  batch?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `migrationTime` field. */
  migrationTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An input for mutations affecting `SchemaMigration` */
export type SchemaMigrationInput = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migrationTime?: InputMaybe<Scalars['Datetime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `SchemaMigration`. Fields that are set will be updated. */
export type SchemaMigrationPatch = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migrationTime?: InputMaybe<Scalars['Datetime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `SchemaMigration` values. */
export type SchemaMigrationsConnection = {
  __typename?: 'SchemaMigrationsConnection';
  /** A list of edges which contains the `SchemaMigration` and cursor to aid in pagination. */
  edges: Array<SchemaMigrationsEdge>;
  /** A list of `SchemaMigration` objects. */
  nodes: Array<Maybe<SchemaMigration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SchemaMigration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SchemaMigration` edge in the connection. */
export type SchemaMigrationsEdge = {
  __typename?: 'SchemaMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SchemaMigration` at the end of the edge. */
  node?: Maybe<SchemaMigration>;
};

export type SchemaMigrationsLock = Node & {
  __typename?: 'SchemaMigrationsLock';
  index: Scalars['Int']['output'];
  isLocked?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `SchemaMigrationsLock` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SchemaMigrationsLockCondition = {
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isLocked` field. */
  isLocked?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `SchemaMigrationsLock` */
export type SchemaMigrationsLockInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  isLocked?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SchemaMigrationsLock`. Fields that are set will be updated. */
export type SchemaMigrationsLockPatch = {
  index?: InputMaybe<Scalars['Int']['input']>;
  isLocked?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `SchemaMigrationsLock` values. */
export type SchemaMigrationsLocksConnection = {
  __typename?: 'SchemaMigrationsLocksConnection';
  /** A list of edges which contains the `SchemaMigrationsLock` and cursor to aid in pagination. */
  edges: Array<SchemaMigrationsLocksEdge>;
  /** A list of `SchemaMigrationsLock` objects. */
  nodes: Array<Maybe<SchemaMigrationsLock>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SchemaMigrationsLock` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SchemaMigrationsLock` edge in the connection. */
export type SchemaMigrationsLocksEdge = {
  __typename?: 'SchemaMigrationsLocksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SchemaMigrationsLock` at the end of the edge. */
  node?: Maybe<SchemaMigrationsLock>;
};

/** Methods to use when ordering `SchemaMigrationsLock`. */
export enum SchemaMigrationsLocksOrderBy {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IsLockedAsc = 'IS_LOCKED_ASC',
  IsLockedDesc = 'IS_LOCKED_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Methods to use when ordering `SchemaMigration`. */
export enum SchemaMigrationsOrderBy {
  BatchAsc = 'BATCH_ASC',
  BatchDesc = 'BATCH_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MigrationTimeAsc = 'MIGRATION_TIME_ASC',
  MigrationTimeDesc = 'MIGRATION_TIME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type SellerReview = Node & {
  __typename?: 'SellerReview';
  buyerId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `CarsForSale` that is related to this `SellerReview`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  listingId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  reviewText?: Maybe<Scalars['String']['output']>;
  sellerId?: Maybe<Scalars['Int']['output']>;
  transactionCompleted?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userBySellerId?: Maybe<User>;
};

/**
 * A condition to be used against `SellerReview` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SellerReviewCondition = {
  /** Checks for equality with the object’s `buyerId` field. */
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `listingId` field. */
  listingId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rating` field. */
  rating?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reviewText` field. */
  reviewText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sellerId` field. */
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `transactionCompleted` field. */
  transactionCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An input for mutations affecting `SellerReview` */
export type SellerReviewInput = {
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listingId?: InputMaybe<Scalars['Int']['input']>;
  rating: Scalars['Int']['input'];
  reviewText?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  transactionCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `SellerReview`. Fields that are set will be updated. */
export type SellerReviewPatch = {
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listingId?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviewText?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  transactionCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `SellerReview` values. */
export type SellerReviewsConnection = {
  __typename?: 'SellerReviewsConnection';
  /** A list of edges which contains the `SellerReview` and cursor to aid in pagination. */
  edges: Array<SellerReviewsEdge>;
  /** A list of `SellerReview` objects. */
  nodes: Array<Maybe<SellerReview>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SellerReview` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SellerReview` edge in the connection. */
export type SellerReviewsEdge = {
  __typename?: 'SellerReviewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SellerReview` at the end of the edge. */
  node?: Maybe<SellerReview>;
};

/** Methods to use when ordering `SellerReview`. */
export enum SellerReviewsOrderBy {
  BuyerIdAsc = 'BUYER_ID_ASC',
  BuyerIdDesc = 'BUYER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ListingIdAsc = 'LISTING_ID_ASC',
  ListingIdDesc = 'LISTING_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RatingAsc = 'RATING_ASC',
  RatingDesc = 'RATING_DESC',
  ReviewTextAsc = 'REVIEW_TEXT_ASC',
  ReviewTextDesc = 'REVIEW_TEXT_DESC',
  SellerIdAsc = 'SELLER_ID_ASC',
  SellerIdDesc = 'SELLER_ID_DESC',
  TransactionCompletedAsc = 'TRANSACTION_COMPLETED_ASC',
  TransactionCompletedDesc = 'TRANSACTION_COMPLETED_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type SellerVerification = Node & {
  __typename?: 'SellerVerification';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `SellerVerification`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  verificationData?: Maybe<Scalars['JSON']['output']>;
  verificationStatus: Scalars['String']['output'];
  verificationType: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `SellerVerification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SellerVerificationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rejectionReason` field. */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `verificationData` field. */
  verificationData?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `verificationStatus` field. */
  verificationStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `verificationType` field. */
  verificationType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `verifiedAt` field. */
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An input for mutations affecting `SellerVerification` */
export type SellerVerificationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  verificationData?: InputMaybe<Scalars['JSON']['input']>;
  verificationStatus?: InputMaybe<Scalars['String']['input']>;
  verificationType: Scalars['String']['input'];
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `SellerVerification`. Fields that are set will be updated. */
export type SellerVerificationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  verificationData?: InputMaybe<Scalars['JSON']['input']>;
  verificationStatus?: InputMaybe<Scalars['String']['input']>;
  verificationType?: InputMaybe<Scalars['String']['input']>;
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `SellerVerification` values. */
export type SellerVerificationsConnection = {
  __typename?: 'SellerVerificationsConnection';
  /** A list of edges which contains the `SellerVerification` and cursor to aid in pagination. */
  edges: Array<SellerVerificationsEdge>;
  /** A list of `SellerVerification` objects. */
  nodes: Array<Maybe<SellerVerification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SellerVerification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SellerVerification` edge in the connection. */
export type SellerVerificationsEdge = {
  __typename?: 'SellerVerificationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SellerVerification` at the end of the edge. */
  node?: Maybe<SellerVerification>;
};

/** Methods to use when ordering `SellerVerification`. */
export enum SellerVerificationsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RejectionReasonAsc = 'REJECTION_REASON_ASC',
  RejectionReasonDesc = 'REJECTION_REASON_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  VerificationDataAsc = 'VERIFICATION_DATA_ASC',
  VerificationDataDesc = 'VERIFICATION_DATA_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC',
  VerificationTypeAsc = 'VERIFICATION_TYPE_ASC',
  VerificationTypeDesc = 'VERIFICATION_TYPE_DESC',
  VerifiedAtAsc = 'VERIFIED_AT_ASC',
  VerifiedAtDesc = 'VERIFIED_AT_DESC'
}

/** All input for the `updateCarModelById` mutation. */
export type UpdateCarModelByIdInput = {
  /** An object where the defined keys will be set on the `CarModel` being updated. */
  carModelPatch: CarModelPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `updateCarModel` mutation. */
export type UpdateCarModelInput = {
  /** An object where the defined keys will be set on the `CarModel` being updated. */
  carModelPatch: CarModelPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CarModel` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CarModel` mutation. */
export type UpdateCarModelPayload = {
  __typename?: 'UpdateCarModelPayload';
  /** The `CarModel` that was updated by this mutation. */
  carModel?: Maybe<CarModel>;
  /** An edge for our `CarModel`. May be used by Relay 1. */
  carModelEdge?: Maybe<CarModelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PopularMake` that is related to this `CarModel`. */
  popularMakeByIdPopularMake?: Maybe<PopularMake>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CarModel` mutation. */
export type UpdateCarModelPayloadCarModelEdgeArgs = {
  orderBy?: InputMaybe<Array<CarModelsOrderBy>>;
};

/** All input for the `updateCarsForSaleById` mutation. */
export type UpdateCarsForSaleByIdInput = {
  /** An object where the defined keys will be set on the `CarsForSale` being updated. */
  carsForSalePatch: CarsForSalePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `updateCarsForSale` mutation. */
export type UpdateCarsForSaleInput = {
  /** An object where the defined keys will be set on the `CarsForSale` being updated. */
  carsForSalePatch: CarsForSalePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CarsForSale` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CarsForSale` mutation. */
export type UpdateCarsForSalePayload = {
  __typename?: 'UpdateCarsForSalePayload';
  /** Reads a single `CarModel` that is related to this `CarsForSale`. */
  carModelByIdCarModel?: Maybe<CarModel>;
  /** The `CarsForSale` that was updated by this mutation. */
  carsForSale?: Maybe<CarsForSale>;
  /** An edge for our `CarsForSale`. May be used by Relay 1. */
  carsForSaleEdge?: Maybe<CarsForSalesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PopularMake` that is related to this `CarsForSale`. */
  popularMakeByIdCarMake?: Maybe<PopularMake>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySellerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CarsForSale`. */
  userBySoldToUserId?: Maybe<User>;
  /** Reads a single `VehicleCatalog` that is related to this `CarsForSale`. */
  vehicleCatalogByCatalogSourceId?: Maybe<VehicleCatalog>;
};


/** The output of our update `CarsForSale` mutation. */
export type UpdateCarsForSalePayloadCarsForSaleEdgeArgs = {
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};

/** All input for the `updateConversationById` mutation. */
export type UpdateConversationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Conversation` being updated. */
  conversationPatch: ConversationPatch;
  id: Scalars['Int']['input'];
};

/** All input for the `updateConversationByListingIdAndBuyerIdAndSellerId` mutation. */
export type UpdateConversationByListingIdAndBuyerIdAndSellerIdInput = {
  buyerId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Conversation` being updated. */
  conversationPatch: ConversationPatch;
  listingId: Scalars['Int']['input'];
  sellerId: Scalars['Int']['input'];
};

/** All input for the `updateConversation` mutation. */
export type UpdateConversationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Conversation` being updated. */
  conversationPatch: ConversationPatch;
  /** The globally unique `ID` which will identify a single `Conversation` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Conversation` mutation. */
export type UpdateConversationPayload = {
  __typename?: 'UpdateConversationPayload';
  /** Reads a single `CarsForSale` that is related to this `Conversation`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Conversation` that was updated by this mutation. */
  conversation?: Maybe<Conversation>;
  /** An edge for our `Conversation`. May be used by Relay 1. */
  conversationEdge?: Maybe<ConversationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Conversation`. */
  userBySellerId?: Maybe<User>;
};


/** The output of our update `Conversation` mutation. */
export type UpdateConversationPayloadConversationEdgeArgs = {
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};

/** All input for the `updateEmailVerificationPinById` mutation. */
export type UpdateEmailVerificationPinByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailVerificationPin` being updated. */
  emailVerificationPinPatch: EmailVerificationPinPatch;
  id: Scalars['Int']['input'];
};

/** All input for the `updateEmailVerificationPin` mutation. */
export type UpdateEmailVerificationPinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailVerificationPin` being updated. */
  emailVerificationPinPatch: EmailVerificationPinPatch;
  /** The globally unique `ID` which will identify a single `EmailVerificationPin` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `EmailVerificationPin` mutation. */
export type UpdateEmailVerificationPinPayload = {
  __typename?: 'UpdateEmailVerificationPinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailVerificationPin` that was updated by this mutation. */
  emailVerificationPin?: Maybe<EmailVerificationPin>;
  /** An edge for our `EmailVerificationPin`. May be used by Relay 1. */
  emailVerificationPinEdge?: Maybe<EmailVerificationPinsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailVerificationPin`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `EmailVerificationPin` mutation. */
export type UpdateEmailVerificationPinPayloadEmailVerificationPinEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailVerificationPinsOrderBy>>;
};

/** All input for the `updateEmailVerificationResendById` mutation. */
export type UpdateEmailVerificationResendByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailVerificationResend` being updated. */
  emailVerificationResendPatch: EmailVerificationResendPatch;
  id: Scalars['Int']['input'];
};

/** All input for the `updateEmailVerificationResend` mutation. */
export type UpdateEmailVerificationResendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailVerificationResend` being updated. */
  emailVerificationResendPatch: EmailVerificationResendPatch;
  /** The globally unique `ID` which will identify a single `EmailVerificationResend` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `EmailVerificationResend` mutation. */
export type UpdateEmailVerificationResendPayload = {
  __typename?: 'UpdateEmailVerificationResendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailVerificationResend` that was updated by this mutation. */
  emailVerificationResend?: Maybe<EmailVerificationResend>;
  /** An edge for our `EmailVerificationResend`. May be used by Relay 1. */
  emailVerificationResendEdge?: Maybe<EmailVerificationResendsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailVerificationResend`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `EmailVerificationResend` mutation. */
export type UpdateEmailVerificationResendPayloadEmailVerificationResendEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailVerificationResendsOrderBy>>;
};

/** All input for the `updatePopularMakeById` mutation. */
export type UpdatePopularMakeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `PopularMake` being updated. */
  popularMakePatch: PopularMakePatch;
};

/** All input for the `updatePopularMake` mutation. */
export type UpdatePopularMakeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PopularMake` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PopularMake` being updated. */
  popularMakePatch: PopularMakePatch;
};

/** The output of our update `PopularMake` mutation. */
export type UpdatePopularMakePayload = {
  __typename?: 'UpdatePopularMakePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PopularMake` that was updated by this mutation. */
  popularMake?: Maybe<PopularMake>;
  /** An edge for our `PopularMake`. May be used by Relay 1. */
  popularMakeEdge?: Maybe<PopularMakesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PopularMake` mutation. */
export type UpdatePopularMakePayloadPopularMakeEdgeArgs = {
  orderBy?: InputMaybe<Array<PopularMakesOrderBy>>;
};

/** All input for the `updatePrivateMessageById` mutation. */
export type UpdatePrivateMessageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `PrivateMessage` being updated. */
  privateMessagePatch: PrivateMessagePatch;
};

/** All input for the `updatePrivateMessage` mutation. */
export type UpdatePrivateMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PrivateMessage` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PrivateMessage` being updated. */
  privateMessagePatch: PrivateMessagePatch;
};

/** The output of our update `PrivateMessage` mutation. */
export type UpdatePrivateMessagePayload = {
  __typename?: 'UpdatePrivateMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Conversation` that is related to this `PrivateMessage`. */
  conversationByConversationId?: Maybe<Conversation>;
  /** The `PrivateMessage` that was updated by this mutation. */
  privateMessage?: Maybe<PrivateMessage>;
  /** An edge for our `PrivateMessage`. May be used by Relay 1. */
  privateMessageEdge?: Maybe<PrivateMessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PrivateMessage`. */
  userBySenderId?: Maybe<User>;
};


/** The output of our update `PrivateMessage` mutation. */
export type UpdatePrivateMessagePayloadPrivateMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<PrivateMessagesOrderBy>>;
};

/** All input for the `updatePublicCommentById` mutation. */
export type UpdatePublicCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `PublicComment` being updated. */
  publicCommentPatch: PublicCommentPatch;
};

/** All input for the `updatePublicComment` mutation. */
export type UpdatePublicCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PublicComment` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PublicComment` being updated. */
  publicCommentPatch: PublicCommentPatch;
};

/** The output of our update `PublicComment` mutation. */
export type UpdatePublicCommentPayload = {
  __typename?: 'UpdatePublicCommentPayload';
  /** Reads a single `CarsForSale` that is related to this `PublicComment`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PublicComment` that was updated by this mutation. */
  publicComment?: Maybe<PublicComment>;
  /** Reads a single `PublicComment` that is related to this `PublicComment`. */
  publicCommentByParentCommentId?: Maybe<PublicComment>;
  /** An edge for our `PublicComment`. May be used by Relay 1. */
  publicCommentEdge?: Maybe<PublicCommentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PublicComment`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `PublicComment` mutation. */
export type UpdatePublicCommentPayloadPublicCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PublicCommentsOrderBy>>;
};

/** All input for the `updateSchemaMigrationById` mutation. */
export type UpdateSchemaMigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SchemaMigration` being updated. */
  schemaMigrationPatch: SchemaMigrationPatch;
};

/** All input for the `updateSchemaMigration` mutation. */
export type UpdateSchemaMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaMigration` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SchemaMigration` being updated. */
  schemaMigrationPatch: SchemaMigrationPatch;
};

/** The output of our update `SchemaMigration` mutation. */
export type UpdateSchemaMigrationPayload = {
  __typename?: 'UpdateSchemaMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigration` that was updated by this mutation. */
  schemaMigration?: Maybe<SchemaMigration>;
  /** An edge for our `SchemaMigration`. May be used by Relay 1. */
  schemaMigrationEdge?: Maybe<SchemaMigrationsEdge>;
};


/** The output of our update `SchemaMigration` mutation. */
export type UpdateSchemaMigrationPayloadSchemaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};

/** All input for the `updateSchemaMigrationsLockByIndex` mutation. */
export type UpdateSchemaMigrationsLockByIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SchemaMigrationsLock` being updated. */
  schemaMigrationsLockPatch: SchemaMigrationsLockPatch;
};

/** All input for the `updateSchemaMigrationsLock` mutation. */
export type UpdateSchemaMigrationsLockInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaMigrationsLock` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SchemaMigrationsLock` being updated. */
  schemaMigrationsLockPatch: SchemaMigrationsLockPatch;
};

/** The output of our update `SchemaMigrationsLock` mutation. */
export type UpdateSchemaMigrationsLockPayload = {
  __typename?: 'UpdateSchemaMigrationsLockPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigrationsLock` that was updated by this mutation. */
  schemaMigrationsLock?: Maybe<SchemaMigrationsLock>;
  /** An edge for our `SchemaMigrationsLock`. May be used by Relay 1. */
  schemaMigrationsLockEdge?: Maybe<SchemaMigrationsLocksEdge>;
};


/** The output of our update `SchemaMigrationsLock` mutation. */
export type UpdateSchemaMigrationsLockPayloadSchemaMigrationsLockEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsLocksOrderBy>>;
};

/** All input for the `updateSellerReviewByBuyerIdAndListingId` mutation. */
export type UpdateSellerReviewByBuyerIdAndListingIdInput = {
  buyerId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SellerReview` being updated. */
  sellerReviewPatch: SellerReviewPatch;
};

/** All input for the `updateSellerReviewById` mutation. */
export type UpdateSellerReviewByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SellerReview` being updated. */
  sellerReviewPatch: SellerReviewPatch;
};

/** All input for the `updateSellerReview` mutation. */
export type UpdateSellerReviewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SellerReview` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SellerReview` being updated. */
  sellerReviewPatch: SellerReviewPatch;
};

/** The output of our update `SellerReview` mutation. */
export type UpdateSellerReviewPayload = {
  __typename?: 'UpdateSellerReviewPayload';
  /** Reads a single `CarsForSale` that is related to this `SellerReview`. */
  carsForSaleByListingId?: Maybe<CarsForSale>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SellerReview` that was updated by this mutation. */
  sellerReview?: Maybe<SellerReview>;
  /** An edge for our `SellerReview`. May be used by Relay 1. */
  sellerReviewEdge?: Maybe<SellerReviewsEdge>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userByBuyerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SellerReview`. */
  userBySellerId?: Maybe<User>;
};


/** The output of our update `SellerReview` mutation. */
export type UpdateSellerReviewPayloadSellerReviewEdgeArgs = {
  orderBy?: InputMaybe<Array<SellerReviewsOrderBy>>;
};

/** All input for the `updateSellerVerificationById` mutation. */
export type UpdateSellerVerificationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SellerVerification` being updated. */
  sellerVerificationPatch: SellerVerificationPatch;
};

/** All input for the `updateSellerVerificationByUserIdAndVerificationType` mutation. */
export type UpdateSellerVerificationByUserIdAndVerificationTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `SellerVerification` being updated. */
  sellerVerificationPatch: SellerVerificationPatch;
  userId: Scalars['Int']['input'];
  verificationType: Scalars['String']['input'];
};

/** All input for the `updateSellerVerification` mutation. */
export type UpdateSellerVerificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SellerVerification` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SellerVerification` being updated. */
  sellerVerificationPatch: SellerVerificationPatch;
};

/** The output of our update `SellerVerification` mutation. */
export type UpdateSellerVerificationPayload = {
  __typename?: 'UpdateSellerVerificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SellerVerification` that was updated by this mutation. */
  sellerVerification?: Maybe<SellerVerification>;
  /** An edge for our `SellerVerification`. May be used by Relay 1. */
  sellerVerificationEdge?: Maybe<SellerVerificationsEdge>;
  /** Reads a single `User` that is related to this `SellerVerification`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `SellerVerification` mutation. */
export type UpdateSellerVerificationPayloadSellerVerificationEdgeArgs = {
  orderBy?: InputMaybe<Array<SellerVerificationsOrderBy>>;
};

/** All input for the `updateUserByEmail` mutation. */
export type UpdateUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** All input for the `updateUserById` mutation. */
export type UpdateUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** All input for the `updateUserByPhoneNumber` mutation. */
export type UpdateUserByPhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateVehicleCatalogBySourceId` mutation. */
export type UpdateVehicleCatalogBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `VehicleCatalog` being updated. */
  vehicleCatalogPatch: VehicleCatalogPatch;
};

/** All input for the `updateVehicleCatalog` mutation. */
export type UpdateVehicleCatalogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VehicleCatalog` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VehicleCatalog` being updated. */
  vehicleCatalogPatch: VehicleCatalogPatch;
};

/** The output of our update `VehicleCatalog` mutation. */
export type UpdateVehicleCatalogPayload = {
  __typename?: 'UpdateVehicleCatalogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VehicleCatalog` that was updated by this mutation. */
  vehicleCatalog?: Maybe<VehicleCatalog>;
  /** An edge for our `VehicleCatalog`. May be used by Relay 1. */
  vehicleCatalogEdge?: Maybe<VehicleCatalogsEdge>;
};


/** The output of our update `VehicleCatalog` mutation. */
export type UpdateVehicleCatalogPayloadVehicleCatalogEdgeArgs = {
  orderBy?: InputMaybe<Array<VehicleCatalogsOrderBy>>;
};

export type User = Node & {
  __typename?: 'User';
  averageRating?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `CarsForSale`. */
  carsForSalesBySellerId: CarsForSalesConnection;
  /** Reads and enables pagination through a set of `CarsForSale`. */
  carsForSalesBySoldToUserId: CarsForSalesConnection;
  /** Reads and enables pagination through a set of `Conversation`. */
  conversationsByBuyerId: ConversationsConnection;
  /** Reads and enables pagination through a set of `Conversation`. */
  conversationsBySellerId: ConversationsConnection;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  email: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `EmailVerificationPin`. */
  emailVerificationPinsByUserId: EmailVerificationPinsConnection;
  /** Reads and enables pagination through a set of `EmailVerificationResend`. */
  emailVerificationResendsByUserId: EmailVerificationResendsConnection;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identityVerified?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  passwordHash: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `PrivateMessage`. */
  privateMessagesBySenderId: PrivateMessagesConnection;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PublicComment`. */
  publicCommentsByUserId: PublicCommentsConnection;
  /** Reads and enables pagination through a set of `SellerReview`. */
  sellerReviewsByBuyerId: SellerReviewsConnection;
  /** Reads and enables pagination through a set of `SellerReview`. */
  sellerReviewsBySellerId: SellerReviewsConnection;
  /** Reads and enables pagination through a set of `SellerVerification`. */
  sellerVerificationsByUserId: SellerVerificationsConnection;
  totalReviews?: Maybe<Scalars['Int']['output']>;
  totalSales?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  verificationLevel?: Maybe<Scalars['Int']['output']>;
};


export type UserCarsForSalesBySellerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarsForSaleCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};


export type UserCarsForSalesBySoldToUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarsForSaleCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};


export type UserConversationsByBuyerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConversationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


export type UserConversationsBySellerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConversationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


export type UserEmailVerificationPinsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailVerificationPinCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailVerificationPinsOrderBy>>;
};


export type UserEmailVerificationResendsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailVerificationResendCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailVerificationResendsOrderBy>>;
};


export type UserPrivateMessagesBySenderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PrivateMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PrivateMessagesOrderBy>>;
};


export type UserPublicCommentsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PublicCommentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublicCommentsOrderBy>>;
};


export type UserSellerReviewsByBuyerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SellerReviewCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SellerReviewsOrderBy>>;
};


export type UserSellerReviewsBySellerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SellerReviewCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SellerReviewsOrderBy>>;
};


export type UserSellerVerificationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SellerVerificationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SellerVerificationsOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `averageRating` field. */
  averageRating?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailVerified` field. */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `firstname` field. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `identityVerified` field. */
  identityVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lastname` field. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `passwordHash` field. */
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneVerified` field. */
  phoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `profilePictureUrl` field. */
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `totalReviews` field. */
  totalReviews?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `totalSales` field. */
  totalSales?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `verificationLevel` field. */
  verificationLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  averageRating?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  passwordHash: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  totalReviews?: InputMaybe<Scalars['Int']['input']>;
  totalSales?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  verificationLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  averageRating?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  totalReviews?: InputMaybe<Scalars['Int']['input']>;
  totalSales?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  verificationLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  AverageRatingAsc = 'AVERAGE_RATING_ASC',
  AverageRatingDesc = 'AVERAGE_RATING_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EmailVerifiedAsc = 'EMAIL_VERIFIED_ASC',
  EmailVerifiedDesc = 'EMAIL_VERIFIED_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  IdentityVerifiedAsc = 'IDENTITY_VERIFIED_ASC',
  IdentityVerifiedDesc = 'IDENTITY_VERIFIED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  Natural = 'NATURAL',
  PasswordHashAsc = 'PASSWORD_HASH_ASC',
  PasswordHashDesc = 'PASSWORD_HASH_DESC',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  PhoneVerifiedAsc = 'PHONE_VERIFIED_ASC',
  PhoneVerifiedDesc = 'PHONE_VERIFIED_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfilePictureUrlAsc = 'PROFILE_PICTURE_URL_ASC',
  ProfilePictureUrlDesc = 'PROFILE_PICTURE_URL_DESC',
  TotalReviewsAsc = 'TOTAL_REVIEWS_ASC',
  TotalReviewsDesc = 'TOTAL_REVIEWS_DESC',
  TotalSalesAsc = 'TOTAL_SALES_ASC',
  TotalSalesDesc = 'TOTAL_SALES_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationLevelAsc = 'VERIFICATION_LEVEL_ASC',
  VerificationLevelDesc = 'VERIFICATION_LEVEL_DESC'
}

export type VehicleCatalog = Node & {
  __typename?: 'VehicleCatalog';
  bodyStyle?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `CarsForSale`. */
  carsForSalesByCatalogSourceId: CarsForSalesConnection;
  createdAt: Scalars['Datetime']['output'];
  doors?: Maybe<Scalars['Int']['output']>;
  driveType?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  sourceId: Scalars['String']['output'];
  transmission?: Maybe<Scalars['String']['output']>;
  trim?: Maybe<Scalars['String']['output']>;
  trimDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  year: Scalars['Int']['output'];
};


export type VehicleCatalogCarsForSalesByCatalogSourceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarsForSaleCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarsForSalesOrderBy>>;
};

/**
 * A condition to be used against `VehicleCatalog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VehicleCatalogCondition = {
  /** Checks for equality with the object’s `bodyStyle` field. */
  bodyStyle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `doors` field. */
  doors?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `driveType` field. */
  driveType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `engine` field. */
  engine?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fuelType` field. */
  fuelType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `make` field. */
  make?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `model` field. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `transmission` field. */
  transmission?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `trim` field. */
  trim?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `trimDescription` field. */
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `VehicleCatalog` */
export type VehicleCatalogInput = {
  bodyStyle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  doors?: InputMaybe<Scalars['Int']['input']>;
  driveType?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  transmission?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  year: Scalars['Int']['input'];
};

/** Distinct (make, model) pairs for search/wizard dropdowns (MVP-2.1). */
export type VehicleCatalogMakeModel = {
  __typename?: 'VehicleCatalogMakeModel';
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `VehicleCatalogMakeModel` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VehicleCatalogMakeModelCondition = {
  /** Checks for equality with the object’s `make` field. */
  make?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `model` field. */
  model?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `VehicleCatalogMakeModel` values. */
export type VehicleCatalogMakeModelsConnection = {
  __typename?: 'VehicleCatalogMakeModelsConnection';
  /** A list of edges which contains the `VehicleCatalogMakeModel` and cursor to aid in pagination. */
  edges: Array<VehicleCatalogMakeModelsEdge>;
  /** A list of `VehicleCatalogMakeModel` objects. */
  nodes: Array<Maybe<VehicleCatalogMakeModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VehicleCatalogMakeModel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VehicleCatalogMakeModel` edge in the connection. */
export type VehicleCatalogMakeModelsEdge = {
  __typename?: 'VehicleCatalogMakeModelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VehicleCatalogMakeModel` at the end of the edge. */
  node?: Maybe<VehicleCatalogMakeModel>;
};

/** Methods to use when ordering `VehicleCatalogMakeModel`. */
export enum VehicleCatalogMakeModelsOrderBy {
  MakeAsc = 'MAKE_ASC',
  MakeDesc = 'MAKE_DESC',
  ModelAsc = 'MODEL_ASC',
  ModelDesc = 'MODEL_DESC',
  Natural = 'NATURAL'
}

/** Represents an update to a `VehicleCatalog`. Fields that are set will be updated. */
export type VehicleCatalogPatch = {
  bodyStyle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  doors?: InputMaybe<Scalars['Int']['input']>;
  driveType?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `VehicleCatalog` values. */
export type VehicleCatalogsConnection = {
  __typename?: 'VehicleCatalogsConnection';
  /** A list of edges which contains the `VehicleCatalog` and cursor to aid in pagination. */
  edges: Array<VehicleCatalogsEdge>;
  /** A list of `VehicleCatalog` objects. */
  nodes: Array<Maybe<VehicleCatalog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VehicleCatalog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VehicleCatalog` edge in the connection. */
export type VehicleCatalogsEdge = {
  __typename?: 'VehicleCatalogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VehicleCatalog` at the end of the edge. */
  node?: Maybe<VehicleCatalog>;
};

/** Methods to use when ordering `VehicleCatalog`. */
export enum VehicleCatalogsOrderBy {
  BodyStyleAsc = 'BODY_STYLE_ASC',
  BodyStyleDesc = 'BODY_STYLE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DoorsAsc = 'DOORS_ASC',
  DoorsDesc = 'DOORS_DESC',
  DriveTypeAsc = 'DRIVE_TYPE_ASC',
  DriveTypeDesc = 'DRIVE_TYPE_DESC',
  EngineAsc = 'ENGINE_ASC',
  EngineDesc = 'ENGINE_DESC',
  FuelTypeAsc = 'FUEL_TYPE_ASC',
  FuelTypeDesc = 'FUEL_TYPE_DESC',
  MakeAsc = 'MAKE_ASC',
  MakeDesc = 'MAKE_DESC',
  ModelAsc = 'MODEL_ASC',
  ModelDesc = 'MODEL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceIdAsc = 'SOURCE_ID_ASC',
  SourceIdDesc = 'SOURCE_ID_DESC',
  TransmissionAsc = 'TRANSMISSION_ASC',
  TransmissionDesc = 'TRANSMISSION_DESC',
  TrimAsc = 'TRIM_ASC',
  TrimDesc = 'TRIM_DESC',
  TrimDescriptionAsc = 'TRIM_DESCRIPTION_ASC',
  TrimDescriptionDesc = 'TRIM_DESCRIPTION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

export type CreateCarForSaleMutationVariables = Exact<{
  sellerId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  mileage?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  price: Scalars['BigFloat']['input'];
  imageLoc: Scalars['JSON']['input'];
  videoLoc?: InputMaybe<Scalars['JSON']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  driveType?: InputMaybe<Scalars['String']['input']>;
  bodyStyle?: InputMaybe<Scalars['String']['input']>;
  exteriorColor?: InputMaybe<Scalars['String']['input']>;
  interiorColor?: InputMaybe<Scalars['String']['input']>;
  titleStatus?: InputMaybe<Scalars['String']['input']>;
  titleImageKey?: InputMaybe<Scalars['String']['input']>;
  hasVerifiedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  catalogSourceId?: InputMaybe<Scalars['String']['input']>;
  unmatchedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  catalogMatchConfidence?: InputMaybe<Scalars['BigFloat']['input']>;
  catalogMatchStage?: InputMaybe<Scalars['String']['input']>;
  normalizedMake?: InputMaybe<Scalars['String']['input']>;
  normalizedModel?: InputMaybe<Scalars['String']['input']>;
  identityProvider?: InputMaybe<Scalars['String']['input']>;
  identityProviderTier?: InputMaybe<Scalars['String']['input']>;
  identityStyleKey?: InputMaybe<Scalars['String']['input']>;
  identityVersion?: InputMaybe<Scalars['String']['input']>;
  identityConfidenceRaw?: InputMaybe<Scalars['String']['input']>;
  identityConfidenceScore?: InputMaybe<Scalars['BigFloat']['input']>;
  identityDecodedAt?: InputMaybe<Scalars['Datetime']['input']>;
  identityDisplayTitle?: InputMaybe<Scalars['String']['input']>;
  identitySnapshot?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateCarForSaleMutation = { __typename?: 'Mutation', createCarsForSale?: { __typename?: 'CreateCarsForSalePayload', clientMutationId?: string | null, carsForSale?: { __typename?: 'CarsForSale', id: number, createdAt?: any | null } | null } | null };

export type CreateConversationMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  buyerId: Scalars['Int']['input'];
  sellerId: Scalars['Int']['input'];
}>;


export type CreateConversationMutation = { __typename?: 'Mutation', createConversation?: { __typename?: 'CreateConversationPayload', conversation?: { __typename?: 'Conversation', id: number, listingId: number, buyerId: number, sellerId: number, createdAt?: any | null, updatedAt?: any | null, carsForSaleByListingId?: { __typename?: 'CarsForSale', id: number, make?: string | null, model?: string | null, year: number, price: any, imageLoc?: any | null } | null, userByBuyerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, profilePictureUrl?: string | null } | null, userBySellerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, profilePictureUrl?: string | null } | null } | null } | null };

export type CreatePublicCommentMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreatePublicCommentMutation = { __typename?: 'Mutation', createPublicComment?: { __typename?: 'CreatePublicCommentPayload', publicComment?: { __typename?: 'PublicComment', id: number, listingId: number, userId: number, parentCommentId?: number | null, content: string, createdAt?: any | null, updatedAt?: any | null, userByUserId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, profilePictureUrl?: string | null } | null } | null } | null };

export type CreateSellerReviewMutationVariables = Exact<{
  sellerId: Scalars['Int']['input'];
  buyerId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
  reviewText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSellerReviewMutation = { __typename?: 'Mutation', createSellerReview?: { __typename?: 'CreateSellerReviewPayload', clientMutationId?: string | null, sellerReview?: { __typename?: 'SellerReview', id: number, sellerId?: number | null, buyerId?: number | null, listingId?: number | null, rating: number, reviewText?: string | null, createdAt?: any | null } | null } | null };

export type CreateSellerVerificationMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  verificationType: Scalars['String']['input'];
  verificationStatus: Scalars['String']['input'];
  verificationData?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateSellerVerificationMutation = { __typename?: 'Mutation', createSellerVerification?: { __typename?: 'CreateSellerVerificationPayload', clientMutationId?: string | null, sellerVerification?: { __typename?: 'SellerVerification', id: number, userId?: number | null, verificationType: string, verificationStatus: string, createdAt?: any | null } | null } | null };

export type CreateNewUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  passwordHash: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateNewUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', clientMutationId?: string | null, user?: { __typename?: 'User', id: number, email: string, firstname?: string | null, lastname?: string | null } | null } | null };

export type DeletePublicCommentMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
  deletedAt: Scalars['Datetime']['input'];
}>;


export type DeletePublicCommentMutation = { __typename?: 'Mutation', updatePublicCommentById?: { __typename?: 'UpdatePublicCommentPayload', publicComment?: { __typename?: 'PublicComment', id: number, deletedAt?: any | null } | null } | null };

export type MarkListingAsSoldMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  sold: Scalars['Boolean']['input'];
  soldToUserId?: InputMaybe<Scalars['Int']['input']>;
  soldAt?: InputMaybe<Scalars['Datetime']['input']>;
  active: Scalars['Boolean']['input'];
}>;


export type MarkListingAsSoldMutation = { __typename?: 'Mutation', updateCarsForSaleById?: { __typename?: 'UpdateCarsForSalePayload', clientMutationId?: string | null, carsForSale?: { __typename?: 'CarsForSale', id: number, sold?: boolean | null, soldToUserId?: number | null, soldAt?: any | null, active: boolean } | null } | null };

export type MarkMessageAsReadMutationVariables = Exact<{
  messageId: Scalars['Int']['input'];
  readAt: Scalars['Datetime']['input'];
}>;


export type MarkMessageAsReadMutation = { __typename?: 'Mutation', updatePrivateMessageById?: { __typename?: 'UpdatePrivateMessagePayload', privateMessage?: { __typename?: 'PrivateMessage', id: number, readAt?: any | null } | null } | null };

export type SendPrivateMessageMutationVariables = Exact<{
  conversationId: Scalars['Int']['input'];
  senderId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
}>;


export type SendPrivateMessageMutation = { __typename?: 'Mutation', createPrivateMessage?: { __typename?: 'CreatePrivateMessagePayload', privateMessage?: { __typename?: 'PrivateMessage', id: number, conversationId: number, senderId: number, content: string, readAt?: any | null, createdAt?: any | null, userBySenderId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, profilePictureUrl?: string | null } | null } | null } | null };

export type UpdateCarForSaleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  mileage?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  exteriorColor?: InputMaybe<Scalars['String']['input']>;
  interiorColor?: InputMaybe<Scalars['String']['input']>;
  titleStatus?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCarForSaleMutation = { __typename?: 'Mutation', updateCarsForSaleById?: { __typename?: 'UpdateCarsForSalePayload', clientMutationId?: string | null, carsForSale?: { __typename?: 'CarsForSale', id: number, mileage?: number | null, description?: string | null, price: any, latitude?: any | null, longitude?: any | null, locationAddress?: string | null, exteriorColor?: string | null, interiorColor?: string | null, titleStatus?: string | null, updatedAt?: any | null } | null } | null };

export type UpdateCarForSaleActiveMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateCarForSaleActiveMutation = { __typename?: 'Mutation', updateCarsForSaleById?: { __typename?: 'UpdateCarsForSalePayload', clientMutationId?: string | null, carsForSale?: { __typename?: 'CarsForSale', id: number, active: boolean } | null } | null };

export type RelistListingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RelistListingMutation = { __typename?: 'Mutation', updateCarsForSaleById?: { __typename?: 'UpdateCarsForSalePayload', clientMutationId?: string | null, carsForSale?: { __typename?: 'CarsForSale', id: number, active: boolean, sold?: boolean | null, soldAt?: any | null, soldToUserId?: number | null } | null } | null };

export type UpdateSellerVerificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  verificationStatus: Scalars['String']['input'];
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSellerVerificationMutation = { __typename?: 'Mutation', updateSellerVerificationById?: { __typename?: 'UpdateSellerVerificationPayload', clientMutationId?: string | null, sellerVerification?: { __typename?: 'SellerVerification', id: number, verificationStatus: string, verifiedAt?: any | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUserById?: { __typename?: 'UpdateUserPayload', clientMutationId?: string | null, user?: { __typename?: 'User', id: number, email: string, firstname?: string | null, lastname?: string | null, profilePictureUrl?: string | null } | null } | null };

export type GetAllMakeModelGenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMakeModelGenQuery = { __typename?: 'Query', allPopularMakes?: { __typename?: 'PopularMakesConnection', nodes: Array<{ __typename?: 'PopularMake', id: number, name: string, carModelsByIdPopularMake: { __typename?: 'CarModelsConnection', nodes: Array<{ __typename?: 'CarModel', id: number, name: string } | null> } } | null> } | null };

export type GetAllCarsForSaleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCarsForSaleQuery = { __typename?: 'Query', allCarsForSales?: { __typename?: 'CarsForSalesConnection', nodes: Array<{ __typename?: 'CarsForSale', id: number, year: number, make?: string | null, model?: string | null, trim?: string | null, identityDisplayTitle?: string | null, price: any, description?: string | null, sellerId?: number | null, mileage?: number | null, imageLoc?: any | null, createdAt?: any | null, active: boolean, sold?: boolean | null, locationAddress?: string | null, latitude?: any | null, longitude?: any | null, bodyStyle?: string | null, driveType?: string | null, exteriorColor?: string | null, transmission?: string | null, fuelType?: string | null } | null> } | null };

export type CarByIdQueryVariables = Exact<{
  carid: Scalars['Int']['input'];
}>;


export type CarByIdQuery = { __typename?: 'Query', carsForSaleById?: { __typename?: 'CarsForSale', id: number, year: number, make?: string | null, model?: string | null, price: any, description?: string | null, sellerId?: number | null, mileage?: number | null, imageLoc?: any | null, videoLoc?: any | null, createdAt?: any | null, latitude?: any | null, longitude?: any | null, locationAddress?: string | null, vin?: string | null, trim?: string | null, identityDisplayTitle?: string | null, transmission?: string | null, fuelType?: string | null, engine?: string | null, driveType?: string | null, bodyStyle?: string | null, exteriorColor?: string | null, interiorColor?: string | null, titleStatus?: string | null, titleImageKey?: string | null, hasVerifiedTitle?: boolean | null, active?: boolean | null, sold?: boolean | null, seller?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string } | null } | null };

export type GetUserListingsQueryVariables = Exact<{
  sellerId: Scalars['Int']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserListingsQuery = { __typename?: 'Query', allCarsForSales?: { __typename?: 'CarsForSalesConnection', nodes: Array<{ __typename?: 'CarsForSale', id: number, year: number, make?: string | null, model?: string | null, trim?: string | null, identityDisplayTitle?: string | null, price: any, description?: string | null, sellerId?: number | null, mileage?: number | null, imageLoc?: any | null, createdAt?: any | null, active: boolean, sold?: boolean | null, soldAt?: any | null } | null> } | null };

export type GetCatalogMakesModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCatalogMakesModelsQuery = { __typename?: 'Query', allVehicleCatalogMakeModels?: { __typename?: 'VehicleCatalogMakeModelsConnection', nodes: Array<{ __typename?: 'VehicleCatalogMakeModel', make?: string | null, model?: string | null } | null> } | null };

export type GetConversationByListingAndUsersQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
  buyerId: Scalars['Int']['input'];
  sellerId: Scalars['Int']['input'];
}>;


export type GetConversationByListingAndUsersQuery = { __typename?: 'Query', allConversations?: { __typename?: 'ConversationsConnection', nodes: Array<{ __typename?: 'Conversation', id: number, listingId: number, buyerId: number, sellerId: number, createdAt?: any | null, updatedAt?: any | null, carsForSaleByListingId?: { __typename?: 'CarsForSale', id: number, make?: string | null, model?: string | null, year: number, price: any, imageLoc?: any | null } | null, userByBuyerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null, userBySellerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null } | null> } | null };

export type GetPrivateMessagesByConversationIdQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type GetPrivateMessagesByConversationIdQuery = { __typename?: 'Query', allPrivateMessages?: { __typename?: 'PrivateMessagesConnection', nodes: Array<{ __typename?: 'PrivateMessage', id: number, conversationId: number, senderId: number, content: string, readAt?: any | null, createdAt?: any | null, userBySenderId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null } | null> } | null };

export type GetPublicCommentsByListingIdQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type GetPublicCommentsByListingIdQuery = { __typename?: 'Query', allPublicComments?: { __typename?: 'PublicCommentsConnection', nodes: Array<{ __typename?: 'PublicComment', id: number, listingId: number, userId: number, parentCommentId?: number | null, content: string, createdAt?: any | null, updatedAt?: any | null, userByUserId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null } | null> } | null };

export type GetSellerReviewsQueryVariables = Exact<{
  sellerId: Scalars['Int']['input'];
}>;


export type GetSellerReviewsQuery = { __typename?: 'Query', allSellerReviews?: { __typename?: 'SellerReviewsConnection', nodes: Array<{ __typename?: 'SellerReview', id: number, sellerId?: number | null, buyerId?: number | null, listingId?: number | null, rating: number, reviewText?: string | null, transactionCompleted?: boolean | null, createdAt?: any | null, buyer?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string } | null, listing?: { __typename?: 'CarsForSale', id: number, year: number, make?: string | null, model?: string | null, trim?: string | null } | null } | null> } | null };

export type GetSellerVerificationsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetSellerVerificationsQuery = { __typename?: 'Query', allSellerVerifications?: { __typename?: 'SellerVerificationsConnection', nodes: Array<{ __typename?: 'SellerVerification', id: number, userId?: number | null, verificationType: string, verificationStatus: string, verifiedAt?: any | null, expiresAt?: any | null, rejectionReason?: string | null, createdAt?: any | null } | null> } | null };

export type GetUnreadMessagesAsBuyerQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUnreadMessagesAsBuyerQuery = { __typename?: 'Query', allConversations?: { __typename?: 'ConversationsConnection', nodes: Array<{ __typename?: 'Conversation', id: number, sellerId: number, privateMessagesByConversationId: { __typename?: 'PrivateMessagesConnection', nodes: Array<{ __typename?: 'PrivateMessage', id: number, senderId: number } | null> } } | null> } | null };

export type GetUnreadMessagesAsSellerQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUnreadMessagesAsSellerQuery = { __typename?: 'Query', allConversations?: { __typename?: 'ConversationsConnection', nodes: Array<{ __typename?: 'Conversation', id: number, buyerId: number, privateMessagesByConversationId: { __typename?: 'PrivateMessagesConnection', nodes: Array<{ __typename?: 'PrivateMessage', id: number, senderId: number } | null> } } | null> } | null };

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: number, email: string, firstname?: string | null, lastname?: string | null, emailVerified?: boolean | null, identityVerified?: boolean | null, verificationLevel?: number | null, averageRating?: any | null, totalReviews?: number | null, totalSales?: number | null, profilePictureUrl?: string | null, createdAt?: any | null } | null };

export type GetUserConversationsAsBuyerQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserConversationsAsBuyerQuery = { __typename?: 'Query', allConversations?: { __typename?: 'ConversationsConnection', nodes: Array<{ __typename?: 'Conversation', id: number, listingId: number, buyerId: number, sellerId: number, createdAt?: any | null, updatedAt?: any | null, carsForSaleByListingId?: { __typename?: 'CarsForSale', id: number, make?: string | null, model?: string | null, year: number, trim?: string | null, price: any, imageLoc?: any | null } | null, userByBuyerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null, userBySellerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null, privateMessagesByConversationId: { __typename?: 'PrivateMessagesConnection', nodes: Array<{ __typename?: 'PrivateMessage', id: number, content: string, senderId: number, readAt?: any | null, createdAt?: any | null } | null> } } | null> } | null };

export type GetUserConversationsAsSellerQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserConversationsAsSellerQuery = { __typename?: 'Query', allConversations?: { __typename?: 'ConversationsConnection', nodes: Array<{ __typename?: 'Conversation', id: number, listingId: number, buyerId: number, sellerId: number, createdAt?: any | null, updatedAt?: any | null, carsForSaleByListingId?: { __typename?: 'CarsForSale', id: number, make?: string | null, model?: string | null, year: number, trim?: string | null, price: any, imageLoc?: any | null } | null, userByBuyerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null, userBySellerId?: { __typename?: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, profilePictureUrl?: string | null } | null, privateMessagesByConversationId: { __typename?: 'PrivateMessagesConnection', nodes: Array<{ __typename?: 'PrivateMessage', id: number, content: string, senderId: number, readAt?: any | null, createdAt?: any | null } | null> } } | null> } | null };


export const CreateCarForSaleDocument = gql`
    mutation createCarForSale($sellerId: Int!, $year: Int!, $make: String!, $model: String!, $mileage: Int, $description: String!, $price: BigFloat!, $imageLoc: JSON!, $videoLoc: JSON, $latitude: BigFloat, $longitude: BigFloat, $locationAddress: String, $vin: String, $trim: String, $transmission: String, $fuelType: String, $engine: String, $driveType: String, $bodyStyle: String, $exteriorColor: String, $interiorColor: String, $titleStatus: String, $titleImageKey: String, $hasVerifiedTitle: Boolean, $catalogSourceId: String, $unmatchedCatalog: Boolean, $catalogMatchConfidence: BigFloat, $catalogMatchStage: String, $normalizedMake: String, $normalizedModel: String, $identityProvider: String, $identityProviderTier: String, $identityStyleKey: String, $identityVersion: String, $identityConfidenceRaw: String, $identityConfidenceScore: BigFloat, $identityDecodedAt: Datetime, $identityDisplayTitle: String, $identitySnapshot: JSON) {
  createCarsForSale(
    input: {carsForSale: {sellerId: $sellerId, description: $description, imageLoc: $imageLoc, videoLoc: $videoLoc, make: $make, model: $model, mileage: $mileage, price: $price, year: $year, latitude: $latitude, longitude: $longitude, locationAddress: $locationAddress, vin: $vin, trim: $trim, transmission: $transmission, fuelType: $fuelType, engine: $engine, driveType: $driveType, bodyStyle: $bodyStyle, exteriorColor: $exteriorColor, interiorColor: $interiorColor, titleStatus: $titleStatus, titleImageKey: $titleImageKey, hasVerifiedTitle: $hasVerifiedTitle, catalogSourceId: $catalogSourceId, unmatchedCatalog: $unmatchedCatalog, catalogMatchConfidence: $catalogMatchConfidence, catalogMatchStage: $catalogMatchStage, normalizedMake: $normalizedMake, normalizedModel: $normalizedModel, identityProvider: $identityProvider, identityProviderTier: $identityProviderTier, identityStyleKey: $identityStyleKey, identityVersion: $identityVersion, identityConfidenceRaw: $identityConfidenceRaw, identityConfidenceScore: $identityConfidenceScore, identityDecodedAt: $identityDecodedAt, identityDisplayTitle: $identityDisplayTitle, identitySnapshot: $identitySnapshot}}
  ) {
    clientMutationId
    carsForSale {
      id
      createdAt
    }
  }
}
    `;
export type CreateCarForSaleMutationFn = Apollo.MutationFunction<CreateCarForSaleMutation, CreateCarForSaleMutationVariables>;

/**
 * __useCreateCarForSaleMutation__
 *
 * To run a mutation, you first call `useCreateCarForSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarForSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarForSaleMutation, { data, loading, error }] = useCreateCarForSaleMutation({
 *   variables: {
 *      sellerId: // value for 'sellerId'
 *      year: // value for 'year'
 *      make: // value for 'make'
 *      model: // value for 'model'
 *      mileage: // value for 'mileage'
 *      description: // value for 'description'
 *      price: // value for 'price'
 *      imageLoc: // value for 'imageLoc'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      locationAddress: // value for 'locationAddress'
 *      vin: // value for 'vin'
 *      trim: // value for 'trim'
 *      transmission: // value for 'transmission'
 *      fuelType: // value for 'fuelType'
 *      engine: // value for 'engine'
 *      driveType: // value for 'driveType'
 *      bodyStyle: // value for 'bodyStyle'
 *      exteriorColor: // value for 'exteriorColor'
 *      interiorColor: // value for 'interiorColor'
 *      titleStatus: // value for 'titleStatus'
 *      titleImageKey: // value for 'titleImageKey'
 *      hasVerifiedTitle: // value for 'hasVerifiedTitle'
 *      catalogSourceId: // value for 'catalogSourceId'
 *      unmatchedCatalog: // value for 'unmatchedCatalog'
 *      catalogMatchConfidence: // value for 'catalogMatchConfidence'
 *      catalogMatchStage: // value for 'catalogMatchStage'
 *      normalizedMake: // value for 'normalizedMake'
 *      normalizedModel: // value for 'normalizedModel'
 *   },
 * });
 */
export function useCreateCarForSaleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarForSaleMutation, CreateCarForSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarForSaleMutation, CreateCarForSaleMutationVariables>(CreateCarForSaleDocument, options);
      }
export type CreateCarForSaleMutationHookResult = ReturnType<typeof useCreateCarForSaleMutation>;
export type CreateCarForSaleMutationResult = Apollo.MutationResult<CreateCarForSaleMutation>;
export type CreateCarForSaleMutationOptions = Apollo.BaseMutationOptions<CreateCarForSaleMutation, CreateCarForSaleMutationVariables>;
export const CreateConversationDocument = gql`
    mutation createConversation($listingId: Int!, $buyerId: Int!, $sellerId: Int!) {
  createConversation(
    input: {conversation: {listingId: $listingId, buyerId: $buyerId, sellerId: $sellerId}}
  ) {
    conversation {
      id
      listingId
      buyerId
      sellerId
      createdAt
      updatedAt
      carsForSaleByListingId {
        id
        make
        model
        year
        price
        imageLoc
      }
      userByBuyerId {
        id
        firstname
        lastname
        profilePictureUrl
      }
      userBySellerId {
        id
        firstname
        lastname
        profilePictureUrl
      }
    }
  }
}
    `;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      buyerId: // value for 'buyerId'
 *      sellerId: // value for 'sellerId'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const CreatePublicCommentDocument = gql`
    mutation createPublicComment($listingId: Int!, $userId: Int!, $content: String!, $parentCommentId: Int) {
  createPublicComment(
    input: {publicComment: {listingId: $listingId, userId: $userId, content: $content, parentCommentId: $parentCommentId}}
  ) {
    publicComment {
      id
      listingId
      userId
      parentCommentId
      content
      createdAt
      updatedAt
      userByUserId {
        id
        firstname
        lastname
        profilePictureUrl
      }
    }
  }
}
    `;
export type CreatePublicCommentMutationFn = Apollo.MutationFunction<CreatePublicCommentMutation, CreatePublicCommentMutationVariables>;

/**
 * __useCreatePublicCommentMutation__
 *
 * To run a mutation, you first call `useCreatePublicCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicCommentMutation, { data, loading, error }] = useCreatePublicCommentMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      userId: // value for 'userId'
 *      content: // value for 'content'
 *      parentCommentId: // value for 'parentCommentId'
 *   },
 * });
 */
export function useCreatePublicCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicCommentMutation, CreatePublicCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicCommentMutation, CreatePublicCommentMutationVariables>(CreatePublicCommentDocument, options);
      }
export type CreatePublicCommentMutationHookResult = ReturnType<typeof useCreatePublicCommentMutation>;
export type CreatePublicCommentMutationResult = Apollo.MutationResult<CreatePublicCommentMutation>;
export type CreatePublicCommentMutationOptions = Apollo.BaseMutationOptions<CreatePublicCommentMutation, CreatePublicCommentMutationVariables>;
export const CreateSellerReviewDocument = gql`
    mutation createSellerReview($sellerId: Int!, $buyerId: Int!, $listingId: Int!, $rating: Int!, $reviewText: String) {
  createSellerReview(
    input: {sellerReview: {sellerId: $sellerId, buyerId: $buyerId, listingId: $listingId, rating: $rating, reviewText: $reviewText, transactionCompleted: true}}
  ) {
    clientMutationId
    sellerReview {
      id
      sellerId
      buyerId
      listingId
      rating
      reviewText
      createdAt
    }
  }
}
    `;
export type CreateSellerReviewMutationFn = Apollo.MutationFunction<CreateSellerReviewMutation, CreateSellerReviewMutationVariables>;

/**
 * __useCreateSellerReviewMutation__
 *
 * To run a mutation, you first call `useCreateSellerReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellerReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellerReviewMutation, { data, loading, error }] = useCreateSellerReviewMutation({
 *   variables: {
 *      sellerId: // value for 'sellerId'
 *      buyerId: // value for 'buyerId'
 *      listingId: // value for 'listingId'
 *      rating: // value for 'rating'
 *      reviewText: // value for 'reviewText'
 *   },
 * });
 */
export function useCreateSellerReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateSellerReviewMutation, CreateSellerReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellerReviewMutation, CreateSellerReviewMutationVariables>(CreateSellerReviewDocument, options);
      }
export type CreateSellerReviewMutationHookResult = ReturnType<typeof useCreateSellerReviewMutation>;
export type CreateSellerReviewMutationResult = Apollo.MutationResult<CreateSellerReviewMutation>;
export type CreateSellerReviewMutationOptions = Apollo.BaseMutationOptions<CreateSellerReviewMutation, CreateSellerReviewMutationVariables>;
export const CreateSellerVerificationDocument = gql`
    mutation createSellerVerification($userId: Int!, $verificationType: String!, $verificationStatus: String!, $verificationData: JSON) {
  createSellerVerification(
    input: {sellerVerification: {userId: $userId, verificationType: $verificationType, verificationStatus: $verificationStatus, verificationData: $verificationData}}
  ) {
    clientMutationId
    sellerVerification {
      id
      userId
      verificationType
      verificationStatus
      createdAt
    }
  }
}
    `;
export type CreateSellerVerificationMutationFn = Apollo.MutationFunction<CreateSellerVerificationMutation, CreateSellerVerificationMutationVariables>;

/**
 * __useCreateSellerVerificationMutation__
 *
 * To run a mutation, you first call `useCreateSellerVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellerVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellerVerificationMutation, { data, loading, error }] = useCreateSellerVerificationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      verificationType: // value for 'verificationType'
 *      verificationStatus: // value for 'verificationStatus'
 *      verificationData: // value for 'verificationData'
 *   },
 * });
 */
export function useCreateSellerVerificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSellerVerificationMutation, CreateSellerVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellerVerificationMutation, CreateSellerVerificationMutationVariables>(CreateSellerVerificationDocument, options);
      }
export type CreateSellerVerificationMutationHookResult = ReturnType<typeof useCreateSellerVerificationMutation>;
export type CreateSellerVerificationMutationResult = Apollo.MutationResult<CreateSellerVerificationMutation>;
export type CreateSellerVerificationMutationOptions = Apollo.BaseMutationOptions<CreateSellerVerificationMutation, CreateSellerVerificationMutationVariables>;
export const CreateNewUserDocument = gql`
    mutation createNewUser($email: String!, $passwordHash: String!, $firstname: String, $lastname: String) {
  createUser(
    input: {user: {email: $email, passwordHash: $passwordHash, firstname: $firstname, lastname: $lastname}}
  ) {
    clientMutationId
    user {
      id
      email
      firstname
      lastname
    }
  }
}
    `;
export type CreateNewUserMutationFn = Apollo.MutationFunction<CreateNewUserMutation, CreateNewUserMutationVariables>;

/**
 * __useCreateNewUserMutation__
 *
 * To run a mutation, you first call `useCreateNewUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewUserMutation, { data, loading, error }] = useCreateNewUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      passwordHash: // value for 'passwordHash'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *   },
 * });
 */
export function useCreateNewUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewUserMutation, CreateNewUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewUserMutation, CreateNewUserMutationVariables>(CreateNewUserDocument, options);
      }
export type CreateNewUserMutationHookResult = ReturnType<typeof useCreateNewUserMutation>;
export type CreateNewUserMutationResult = Apollo.MutationResult<CreateNewUserMutation>;
export type CreateNewUserMutationOptions = Apollo.BaseMutationOptions<CreateNewUserMutation, CreateNewUserMutationVariables>;
export const DeletePublicCommentDocument = gql`
    mutation deletePublicComment($commentId: Int!, $deletedAt: Datetime!) {
  updatePublicCommentById(
    input: {id: $commentId, publicCommentPatch: {deletedAt: $deletedAt}}
  ) {
    publicComment {
      id
      deletedAt
    }
  }
}
    `;
export type DeletePublicCommentMutationFn = Apollo.MutationFunction<DeletePublicCommentMutation, DeletePublicCommentMutationVariables>;

/**
 * __useDeletePublicCommentMutation__
 *
 * To run a mutation, you first call `useDeletePublicCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePublicCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePublicCommentMutation, { data, loading, error }] = useDeletePublicCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useDeletePublicCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePublicCommentMutation, DeletePublicCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePublicCommentMutation, DeletePublicCommentMutationVariables>(DeletePublicCommentDocument, options);
      }
export type DeletePublicCommentMutationHookResult = ReturnType<typeof useDeletePublicCommentMutation>;
export type DeletePublicCommentMutationResult = Apollo.MutationResult<DeletePublicCommentMutation>;
export type DeletePublicCommentMutationOptions = Apollo.BaseMutationOptions<DeletePublicCommentMutation, DeletePublicCommentMutationVariables>;
export const MarkListingAsSoldDocument = gql`
    mutation markListingAsSold($id: Int!, $sold: Boolean!, $soldToUserId: Int, $soldAt: Datetime, $active: Boolean!) {
  updateCarsForSaleById(
    input: {id: $id, carsForSalePatch: {sold: $sold, soldToUserId: $soldToUserId, soldAt: $soldAt, active: $active}}
  ) {
    clientMutationId
    carsForSale {
      id
      sold
      soldToUserId
      soldAt
      active
    }
  }
}
    `;
export type MarkListingAsSoldMutationFn = Apollo.MutationFunction<MarkListingAsSoldMutation, MarkListingAsSoldMutationVariables>;

/**
 * __useMarkListingAsSoldMutation__
 *
 * To run a mutation, you first call `useMarkListingAsSoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkListingAsSoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markListingAsSoldMutation, { data, loading, error }] = useMarkListingAsSoldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sold: // value for 'sold'
 *      soldToUserId: // value for 'soldToUserId'
 *      soldAt: // value for 'soldAt'
 *   },
 * });
 */
export function useMarkListingAsSoldMutation(baseOptions?: Apollo.MutationHookOptions<MarkListingAsSoldMutation, MarkListingAsSoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkListingAsSoldMutation, MarkListingAsSoldMutationVariables>(MarkListingAsSoldDocument, options);
      }
export type MarkListingAsSoldMutationHookResult = ReturnType<typeof useMarkListingAsSoldMutation>;
export type MarkListingAsSoldMutationResult = Apollo.MutationResult<MarkListingAsSoldMutation>;
export type MarkListingAsSoldMutationOptions = Apollo.BaseMutationOptions<MarkListingAsSoldMutation, MarkListingAsSoldMutationVariables>;
export const MarkMessageAsReadDocument = gql`
    mutation markMessageAsRead($messageId: Int!, $readAt: Datetime!) {
  updatePrivateMessageById(
    input: {id: $messageId, privateMessagePatch: {readAt: $readAt}}
  ) {
    privateMessage {
      id
      readAt
    }
  }
}
    `;
export type MarkMessageAsReadMutationFn = Apollo.MutationFunction<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>;

/**
 * __useMarkMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessageAsReadMutation, { data, loading, error }] = useMarkMessageAsReadMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      readAt: // value for 'readAt'
 *   },
 * });
 */
export function useMarkMessageAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>(MarkMessageAsReadDocument, options);
      }
export type MarkMessageAsReadMutationHookResult = ReturnType<typeof useMarkMessageAsReadMutation>;
export type MarkMessageAsReadMutationResult = Apollo.MutationResult<MarkMessageAsReadMutation>;
export type MarkMessageAsReadMutationOptions = Apollo.BaseMutationOptions<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>;
export const SendPrivateMessageDocument = gql`
    mutation sendPrivateMessage($conversationId: Int!, $senderId: Int!, $content: String!) {
  createPrivateMessage(
    input: {privateMessage: {conversationId: $conversationId, senderId: $senderId, content: $content}}
  ) {
    privateMessage {
      id
      conversationId
      senderId
      content
      readAt
      createdAt
      userBySenderId {
        id
        firstname
        lastname
        profilePictureUrl
      }
    }
  }
}
    `;
export type SendPrivateMessageMutationFn = Apollo.MutationFunction<SendPrivateMessageMutation, SendPrivateMessageMutationVariables>;

/**
 * __useSendPrivateMessageMutation__
 *
 * To run a mutation, you first call `useSendPrivateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPrivateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPrivateMessageMutation, { data, loading, error }] = useSendPrivateMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      senderId: // value for 'senderId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSendPrivateMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendPrivateMessageMutation, SendPrivateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPrivateMessageMutation, SendPrivateMessageMutationVariables>(SendPrivateMessageDocument, options);
      }
export type SendPrivateMessageMutationHookResult = ReturnType<typeof useSendPrivateMessageMutation>;
export type SendPrivateMessageMutationResult = Apollo.MutationResult<SendPrivateMessageMutation>;
export type SendPrivateMessageMutationOptions = Apollo.BaseMutationOptions<SendPrivateMessageMutation, SendPrivateMessageMutationVariables>;
export const UpdateCarForSaleDocument = gql`
    mutation updateCarForSale($id: Int!, $mileage: Int, $description: String, $price: BigFloat, $latitude: BigFloat, $longitude: BigFloat, $locationAddress: String, $exteriorColor: String, $interiorColor: String, $titleStatus: String) {
  updateCarsForSaleById(
    input: {id: $id, carsForSalePatch: {mileage: $mileage, description: $description, price: $price, latitude: $latitude, longitude: $longitude, locationAddress: $locationAddress, exteriorColor: $exteriorColor, interiorColor: $interiorColor, titleStatus: $titleStatus}}
  ) {
    clientMutationId
    carsForSale {
      id
      mileage
      description
      price
      latitude
      longitude
      locationAddress
      exteriorColor
      interiorColor
      titleStatus
      updatedAt
    }
  }
}
    `;
export type UpdateCarForSaleMutationFn = Apollo.MutationFunction<UpdateCarForSaleMutation, UpdateCarForSaleMutationVariables>;

/**
 * __useUpdateCarForSaleMutation__
 *
 * To run a mutation, you first call `useUpdateCarForSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarForSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarForSaleMutation, { data, loading, error }] = useUpdateCarForSaleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mileage: // value for 'mileage'
 *      description: // value for 'description'
 *      price: // value for 'price'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      locationAddress: // value for 'locationAddress'
 *      exteriorColor: // value for 'exteriorColor'
 *      interiorColor: // value for 'interiorColor'
 *      titleStatus: // value for 'titleStatus'
 *   },
 * });
 */
export function useUpdateCarForSaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarForSaleMutation, UpdateCarForSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarForSaleMutation, UpdateCarForSaleMutationVariables>(UpdateCarForSaleDocument, options);
      }
export type UpdateCarForSaleMutationHookResult = ReturnType<typeof useUpdateCarForSaleMutation>;
export type UpdateCarForSaleMutationResult = Apollo.MutationResult<UpdateCarForSaleMutation>;
export type UpdateCarForSaleMutationOptions = Apollo.BaseMutationOptions<UpdateCarForSaleMutation, UpdateCarForSaleMutationVariables>;
export const UpdateCarForSaleActiveDocument = gql`
    mutation updateCarForSaleActive($id: Int!, $active: Boolean!) {
  updateCarsForSaleById(input: {id: $id, carsForSalePatch: {active: $active}}) {
    clientMutationId
    carsForSale {
      id
      active
    }
  }
}
    `;
export type UpdateCarForSaleActiveMutationFn = Apollo.MutationFunction<UpdateCarForSaleActiveMutation, UpdateCarForSaleActiveMutationVariables>;

export const RelistListingDocument = gql`
    mutation relistListing($id: Int!) {
  updateCarsForSaleById(input: {id: $id, carsForSalePatch: {active: true, sold: false}}) {
    clientMutationId
    carsForSale {
      id
      active
      sold
      soldAt
      soldToUserId
    }
  }
}
    `;
export type RelistListingMutationFn = Apollo.MutationFunction<RelistListingMutation, RelistListingMutationVariables>;

export function useRelistListingMutation(baseOptions?: Apollo.MutationHookOptions<RelistListingMutation, RelistListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RelistListingMutation, RelistListingMutationVariables>(RelistListingDocument, options);
      }
export type RelistListingMutationHookResult = ReturnType<typeof useRelistListingMutation>;
export type RelistListingMutationResult = Apollo.MutationResult<RelistListingMutation>;
export type RelistListingMutationOptions = Apollo.BaseMutationOptions<RelistListingMutation, RelistListingMutationVariables>;

/**
 * __useUpdateCarForSaleActiveMutation__
 *
 * To run a mutation, you first call `useUpdateCarForSaleActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarForSaleActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarForSaleActiveMutation, { data, loading, error }] = useUpdateCarForSaleActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateCarForSaleActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarForSaleActiveMutation, UpdateCarForSaleActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarForSaleActiveMutation, UpdateCarForSaleActiveMutationVariables>(UpdateCarForSaleActiveDocument, options);
      }
export type UpdateCarForSaleActiveMutationHookResult = ReturnType<typeof useUpdateCarForSaleActiveMutation>;
export type UpdateCarForSaleActiveMutationResult = Apollo.MutationResult<UpdateCarForSaleActiveMutation>;
export type UpdateCarForSaleActiveMutationOptions = Apollo.BaseMutationOptions<UpdateCarForSaleActiveMutation, UpdateCarForSaleActiveMutationVariables>;
export const UpdateSellerVerificationDocument = gql`
    mutation updateSellerVerification($id: Int!, $verificationStatus: String!, $verifiedAt: Datetime, $rejectionReason: String) {
  updateSellerVerificationById(
    input: {id: $id, sellerVerificationPatch: {verificationStatus: $verificationStatus, verifiedAt: $verifiedAt, rejectionReason: $rejectionReason}}
  ) {
    clientMutationId
    sellerVerification {
      id
      verificationStatus
      verifiedAt
    }
  }
}
    `;
export type UpdateSellerVerificationMutationFn = Apollo.MutationFunction<UpdateSellerVerificationMutation, UpdateSellerVerificationMutationVariables>;

/**
 * __useUpdateSellerVerificationMutation__
 *
 * To run a mutation, you first call `useUpdateSellerVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerVerificationMutation, { data, loading, error }] = useUpdateSellerVerificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      verificationStatus: // value for 'verificationStatus'
 *      verifiedAt: // value for 'verifiedAt'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useUpdateSellerVerificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerVerificationMutation, UpdateSellerVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerVerificationMutation, UpdateSellerVerificationMutationVariables>(UpdateSellerVerificationDocument, options);
      }
export type UpdateSellerVerificationMutationHookResult = ReturnType<typeof useUpdateSellerVerificationMutation>;
export type UpdateSellerVerificationMutationResult = Apollo.MutationResult<UpdateSellerVerificationMutation>;
export type UpdateSellerVerificationMutationOptions = Apollo.BaseMutationOptions<UpdateSellerVerificationMutation, UpdateSellerVerificationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: Int!, $firstname: String, $lastname: String, $email: String, $profilePictureUrl: String) {
  updateUserById(
    input: {id: $id, userPatch: {firstname: $firstname, lastname: $lastname, email: $email, profilePictureUrl: $profilePictureUrl}}
  ) {
    clientMutationId
    user {
      id
      email
      firstname
      lastname
      profilePictureUrl
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      email: // value for 'email'
 *      profilePictureUrl: // value for 'profilePictureUrl'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetAllMakeModelGenDocument = gql`
    query getAllMakeModelGen {
  allPopularMakes {
    nodes {
      id
      name
      carModelsByIdPopularMake {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllMakeModelGenQuery__
 *
 * To run a query within a React component, call `useGetAllMakeModelGenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMakeModelGenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMakeModelGenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMakeModelGenQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>(GetAllMakeModelGenDocument, options);
      }
export function useGetAllMakeModelGenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>(GetAllMakeModelGenDocument, options);
        }
// @ts-ignore
export function useGetAllMakeModelGenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>;
export function useGetAllMakeModelGenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllMakeModelGenQuery | undefined, GetAllMakeModelGenQueryVariables>;
export function useGetAllMakeModelGenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>(GetAllMakeModelGenDocument, options);
        }
export type GetAllMakeModelGenQueryHookResult = ReturnType<typeof useGetAllMakeModelGenQuery>;
export type GetAllMakeModelGenLazyQueryHookResult = ReturnType<typeof useGetAllMakeModelGenLazyQuery>;
export type GetAllMakeModelGenSuspenseQueryHookResult = ReturnType<typeof useGetAllMakeModelGenSuspenseQuery>;
export type GetAllMakeModelGenQueryResult = Apollo.QueryResult<GetAllMakeModelGenQuery, GetAllMakeModelGenQueryVariables>;
export const GetAllCarsForSaleDocument = gql`
    query getAllCarsForSale {
  allCarsForSales(condition: {active: true, sold: false}) {
    nodes {
      id
      year
      make
      model
      trim
      identityDisplayTitle
      price
      description
      sellerId
      mileage
      imageLoc
      createdAt
      active
      sold
      locationAddress
      latitude
      longitude
      bodyStyle
      driveType
      exteriorColor
      transmission
      fuelType
    }
  }
}
    `;

/**
 * __useGetAllCarsForSaleQuery__
 *
 * To run a query within a React component, call `useGetAllCarsForSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarsForSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCarsForSaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCarsForSaleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>(GetAllCarsForSaleDocument, options);
      }
export function useGetAllCarsForSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>(GetAllCarsForSaleDocument, options);
        }
// @ts-ignore
export function useGetAllCarsForSaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>;
export function useGetAllCarsForSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCarsForSaleQuery | undefined, GetAllCarsForSaleQueryVariables>;
export function useGetAllCarsForSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>(GetAllCarsForSaleDocument, options);
        }
export type GetAllCarsForSaleQueryHookResult = ReturnType<typeof useGetAllCarsForSaleQuery>;
export type GetAllCarsForSaleLazyQueryHookResult = ReturnType<typeof useGetAllCarsForSaleLazyQuery>;
export type GetAllCarsForSaleSuspenseQueryHookResult = ReturnType<typeof useGetAllCarsForSaleSuspenseQuery>;
export type GetAllCarsForSaleQueryResult = Apollo.QueryResult<GetAllCarsForSaleQuery, GetAllCarsForSaleQueryVariables>;
export const CarByIdDocument = gql`
    query carById($carid: Int!) {
  carsForSaleById(id: $carid) {
    id
    year
    make
    model
    price
    description
    sellerId
    mileage
    imageLoc
    videoLoc
    createdAt
    latitude
    longitude
    locationAddress
    vin
    trim
    identityDisplayTitle
    transmission
    fuelType
    engine
    driveType
    bodyStyle
    exteriorColor
    interiorColor
    titleStatus
    titleImageKey
    hasVerifiedTitle
    active
    sold
    seller: userBySellerId {
      id
    }
  }
}
    `;

/**
 * __useCarByIdQuery__
 *
 * To run a query within a React component, call `useCarByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarByIdQuery({
 *   variables: {
 *      carid: // value for 'carid'
 *   },
 * });
 */
export function useCarByIdQuery(baseOptions: Apollo.QueryHookOptions<CarByIdQuery, CarByIdQueryVariables> & ({ variables: CarByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarByIdQuery, CarByIdQueryVariables>(CarByIdDocument, options);
      }
export function useCarByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarByIdQuery, CarByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarByIdQuery, CarByIdQueryVariables>(CarByIdDocument, options);
        }
// @ts-ignore
export function useCarByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarByIdQuery, CarByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CarByIdQuery, CarByIdQueryVariables>;
export function useCarByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CarByIdQuery, CarByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CarByIdQuery | undefined, CarByIdQueryVariables>;
export function useCarByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CarByIdQuery, CarByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarByIdQuery, CarByIdQueryVariables>(CarByIdDocument, options);
        }
export type CarByIdQueryHookResult = ReturnType<typeof useCarByIdQuery>;
export type CarByIdLazyQueryHookResult = ReturnType<typeof useCarByIdLazyQuery>;
export type CarByIdSuspenseQueryHookResult = ReturnType<typeof useCarByIdSuspenseQuery>;
export type CarByIdQueryResult = Apollo.QueryResult<CarByIdQuery, CarByIdQueryVariables>;
export const GetUserListingsDocument = gql`
    query getUserListings($sellerId: Int!, $active: Boolean) {
  allCarsForSales(condition: {sellerId: $sellerId, active: $active}) {
    nodes {
      id
      year
      make
      model
      trim
      identityDisplayTitle
      price
      description
      sellerId
      mileage
      imageLoc
      createdAt
      active
      sold
      soldAt
    }
  }
}
    `;

/**
 * __useGetUserListingsQuery__
 *
 * To run a query within a React component, call `useGetUserListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListingsQuery({
 *   variables: {
 *      sellerId: // value for 'sellerId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUserListingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserListingsQuery, GetUserListingsQueryVariables> & ({ variables: GetUserListingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserListingsQuery, GetUserListingsQueryVariables>(GetUserListingsDocument, options);
      }
export function useGetUserListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserListingsQuery, GetUserListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserListingsQuery, GetUserListingsQueryVariables>(GetUserListingsDocument, options);
        }
// @ts-ignore
export function useGetUserListingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserListingsQuery, GetUserListingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserListingsQuery, GetUserListingsQueryVariables>;
export function useGetUserListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserListingsQuery, GetUserListingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserListingsQuery | undefined, GetUserListingsQueryVariables>;
export function useGetUserListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserListingsQuery, GetUserListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserListingsQuery, GetUserListingsQueryVariables>(GetUserListingsDocument, options);
        }
export type GetUserListingsQueryHookResult = ReturnType<typeof useGetUserListingsQuery>;
export type GetUserListingsLazyQueryHookResult = ReturnType<typeof useGetUserListingsLazyQuery>;
export type GetUserListingsSuspenseQueryHookResult = ReturnType<typeof useGetUserListingsSuspenseQuery>;
export type GetUserListingsQueryResult = Apollo.QueryResult<GetUserListingsQuery, GetUserListingsQueryVariables>;
export const GetCatalogMakesModelsDocument = gql`
    query getCatalogMakesModels {
  allVehicleCatalogMakeModels(first: 20000) {
    nodes {
      make
      model
    }
  }
}
    `;

/**
 * __useGetCatalogMakesModelsQuery__
 *
 * To run a query within a React component, call `useGetCatalogMakesModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogMakesModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogMakesModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCatalogMakesModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>(GetCatalogMakesModelsDocument, options);
      }
export function useGetCatalogMakesModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>(GetCatalogMakesModelsDocument, options);
        }
// @ts-ignore
export function useGetCatalogMakesModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>;
export function useGetCatalogMakesModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCatalogMakesModelsQuery | undefined, GetCatalogMakesModelsQueryVariables>;
export function useGetCatalogMakesModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>(GetCatalogMakesModelsDocument, options);
        }
export type GetCatalogMakesModelsQueryHookResult = ReturnType<typeof useGetCatalogMakesModelsQuery>;
export type GetCatalogMakesModelsLazyQueryHookResult = ReturnType<typeof useGetCatalogMakesModelsLazyQuery>;
export type GetCatalogMakesModelsSuspenseQueryHookResult = ReturnType<typeof useGetCatalogMakesModelsSuspenseQuery>;
export type GetCatalogMakesModelsQueryResult = Apollo.QueryResult<GetCatalogMakesModelsQuery, GetCatalogMakesModelsQueryVariables>;
export const GetConversationByListingAndUsersDocument = gql`
    query getConversationByListingAndUsers($listingId: Int!, $buyerId: Int!, $sellerId: Int!) {
  allConversations(
    condition: {listingId: $listingId, buyerId: $buyerId, sellerId: $sellerId}
    first: 1
  ) {
    nodes {
      id
      listingId
      buyerId
      sellerId
      createdAt
      updatedAt
      carsForSaleByListingId {
        id
        make
        model
        year
        price
        imageLoc
      }
      userByBuyerId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
      userBySellerId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
    }
  }
}
    `;

/**
 * __useGetConversationByListingAndUsersQuery__
 *
 * To run a query within a React component, call `useGetConversationByListingAndUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationByListingAndUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationByListingAndUsersQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      buyerId: // value for 'buyerId'
 *      sellerId: // value for 'sellerId'
 *   },
 * });
 */
export function useGetConversationByListingAndUsersQuery(baseOptions: Apollo.QueryHookOptions<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables> & ({ variables: GetConversationByListingAndUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>(GetConversationByListingAndUsersDocument, options);
      }
export function useGetConversationByListingAndUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>(GetConversationByListingAndUsersDocument, options);
        }
// @ts-ignore
export function useGetConversationByListingAndUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>;
export function useGetConversationByListingAndUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationByListingAndUsersQuery | undefined, GetConversationByListingAndUsersQueryVariables>;
export function useGetConversationByListingAndUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>(GetConversationByListingAndUsersDocument, options);
        }
export type GetConversationByListingAndUsersQueryHookResult = ReturnType<typeof useGetConversationByListingAndUsersQuery>;
export type GetConversationByListingAndUsersLazyQueryHookResult = ReturnType<typeof useGetConversationByListingAndUsersLazyQuery>;
export type GetConversationByListingAndUsersSuspenseQueryHookResult = ReturnType<typeof useGetConversationByListingAndUsersSuspenseQuery>;
export type GetConversationByListingAndUsersQueryResult = Apollo.QueryResult<GetConversationByListingAndUsersQuery, GetConversationByListingAndUsersQueryVariables>;
export const GetPrivateMessagesByConversationIdDocument = gql`
    query getPrivateMessagesByConversationId($conversationId: Int!) {
  allPrivateMessages(
    condition: {conversationId: $conversationId}
    orderBy: CREATED_AT_ASC
  ) {
    nodes {
      id
      conversationId
      senderId
      content
      readAt
      createdAt
      userBySenderId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
    }
  }
}
    `;

/**
 * __useGetPrivateMessagesByConversationIdQuery__
 *
 * To run a query within a React component, call `useGetPrivateMessagesByConversationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateMessagesByConversationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateMessagesByConversationIdQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetPrivateMessagesByConversationIdQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables> & ({ variables: GetPrivateMessagesByConversationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>(GetPrivateMessagesByConversationIdDocument, options);
      }
export function useGetPrivateMessagesByConversationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>(GetPrivateMessagesByConversationIdDocument, options);
        }
// @ts-ignore
export function useGetPrivateMessagesByConversationIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>;
export function useGetPrivateMessagesByConversationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrivateMessagesByConversationIdQuery | undefined, GetPrivateMessagesByConversationIdQueryVariables>;
export function useGetPrivateMessagesByConversationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>(GetPrivateMessagesByConversationIdDocument, options);
        }
export type GetPrivateMessagesByConversationIdQueryHookResult = ReturnType<typeof useGetPrivateMessagesByConversationIdQuery>;
export type GetPrivateMessagesByConversationIdLazyQueryHookResult = ReturnType<typeof useGetPrivateMessagesByConversationIdLazyQuery>;
export type GetPrivateMessagesByConversationIdSuspenseQueryHookResult = ReturnType<typeof useGetPrivateMessagesByConversationIdSuspenseQuery>;
export type GetPrivateMessagesByConversationIdQueryResult = Apollo.QueryResult<GetPrivateMessagesByConversationIdQuery, GetPrivateMessagesByConversationIdQueryVariables>;
export const GetPublicCommentsByListingIdDocument = gql`
    query getPublicCommentsByListingId($listingId: Int!) {
  allPublicComments(
    condition: {listingId: $listingId, deletedAt: null}
    orderBy: CREATED_AT_ASC
  ) {
    nodes {
      id
      listingId
      userId
      parentCommentId
      content
      createdAt
      updatedAt
      userByUserId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
    }
  }
}
    `;

/**
 * __useGetPublicCommentsByListingIdQuery__
 *
 * To run a query within a React component, call `useGetPublicCommentsByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCommentsByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCommentsByListingIdQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetPublicCommentsByListingIdQuery(baseOptions: Apollo.QueryHookOptions<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables> & ({ variables: GetPublicCommentsByListingIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>(GetPublicCommentsByListingIdDocument, options);
      }
export function useGetPublicCommentsByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>(GetPublicCommentsByListingIdDocument, options);
        }
// @ts-ignore
export function useGetPublicCommentsByListingIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>;
export function useGetPublicCommentsByListingIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublicCommentsByListingIdQuery | undefined, GetPublicCommentsByListingIdQueryVariables>;
export function useGetPublicCommentsByListingIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>(GetPublicCommentsByListingIdDocument, options);
        }
export type GetPublicCommentsByListingIdQueryHookResult = ReturnType<typeof useGetPublicCommentsByListingIdQuery>;
export type GetPublicCommentsByListingIdLazyQueryHookResult = ReturnType<typeof useGetPublicCommentsByListingIdLazyQuery>;
export type GetPublicCommentsByListingIdSuspenseQueryHookResult = ReturnType<typeof useGetPublicCommentsByListingIdSuspenseQuery>;
export type GetPublicCommentsByListingIdQueryResult = Apollo.QueryResult<GetPublicCommentsByListingIdQuery, GetPublicCommentsByListingIdQueryVariables>;
export const GetSellerReviewsDocument = gql`
    query getSellerReviews($sellerId: Int!) {
  allSellerReviews(condition: {sellerId: $sellerId}) {
    nodes {
      id
      sellerId
      buyerId
      listingId
      rating
      reviewText
      transactionCompleted
      createdAt
      buyer: userByBuyerId {
        id
        firstname
        lastname
        email
      }
      listing: carsForSaleByListingId {
        id
        year
        make
        model
        trim
      }
    }
  }
}
    `;

/**
 * __useGetSellerReviewsQuery__
 *
 * To run a query within a React component, call `useGetSellerReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellerReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellerReviewsQuery({
 *   variables: {
 *      sellerId: // value for 'sellerId'
 *   },
 * });
 */
export function useGetSellerReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetSellerReviewsQuery, GetSellerReviewsQueryVariables> & ({ variables: GetSellerReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>(GetSellerReviewsDocument, options);
      }
export function useGetSellerReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>(GetSellerReviewsDocument, options);
        }
// @ts-ignore
export function useGetSellerReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>;
export function useGetSellerReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSellerReviewsQuery | undefined, GetSellerReviewsQueryVariables>;
export function useGetSellerReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>(GetSellerReviewsDocument, options);
        }
export type GetSellerReviewsQueryHookResult = ReturnType<typeof useGetSellerReviewsQuery>;
export type GetSellerReviewsLazyQueryHookResult = ReturnType<typeof useGetSellerReviewsLazyQuery>;
export type GetSellerReviewsSuspenseQueryHookResult = ReturnType<typeof useGetSellerReviewsSuspenseQuery>;
export type GetSellerReviewsQueryResult = Apollo.QueryResult<GetSellerReviewsQuery, GetSellerReviewsQueryVariables>;
export const GetSellerVerificationsDocument = gql`
    query getSellerVerifications($userId: Int!) {
  allSellerVerifications(condition: {userId: $userId}) {
    nodes {
      id
      userId
      verificationType
      verificationStatus
      verifiedAt
      expiresAt
      rejectionReason
      createdAt
    }
  }
}
    `;

/**
 * __useGetSellerVerificationsQuery__
 *
 * To run a query within a React component, call `useGetSellerVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellerVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellerVerificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSellerVerificationsQuery(baseOptions: Apollo.QueryHookOptions<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables> & ({ variables: GetSellerVerificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>(GetSellerVerificationsDocument, options);
      }
export function useGetSellerVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>(GetSellerVerificationsDocument, options);
        }
// @ts-ignore
export function useGetSellerVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>;
export function useGetSellerVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSellerVerificationsQuery | undefined, GetSellerVerificationsQueryVariables>;
export function useGetSellerVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>(GetSellerVerificationsDocument, options);
        }
export type GetSellerVerificationsQueryHookResult = ReturnType<typeof useGetSellerVerificationsQuery>;
export type GetSellerVerificationsLazyQueryHookResult = ReturnType<typeof useGetSellerVerificationsLazyQuery>;
export type GetSellerVerificationsSuspenseQueryHookResult = ReturnType<typeof useGetSellerVerificationsSuspenseQuery>;
export type GetSellerVerificationsQueryResult = Apollo.QueryResult<GetSellerVerificationsQuery, GetSellerVerificationsQueryVariables>;
export const GetUnreadMessagesAsBuyerDocument = gql`
    query getUnreadMessagesAsBuyer($userId: Int!) {
  allConversations(condition: {buyerId: $userId}) {
    nodes {
      id
      sellerId
      privateMessagesByConversationId(condition: {readAt: null}) {
        nodes {
          id
          senderId
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnreadMessagesAsBuyerQuery__
 *
 * To run a query within a React component, call `useGetUnreadMessagesAsBuyerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadMessagesAsBuyerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadMessagesAsBuyerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUnreadMessagesAsBuyerQuery(baseOptions: Apollo.QueryHookOptions<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables> & ({ variables: GetUnreadMessagesAsBuyerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>(GetUnreadMessagesAsBuyerDocument, options);
      }
export function useGetUnreadMessagesAsBuyerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>(GetUnreadMessagesAsBuyerDocument, options);
        }
// @ts-ignore
export function useGetUnreadMessagesAsBuyerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>;
export function useGetUnreadMessagesAsBuyerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadMessagesAsBuyerQuery | undefined, GetUnreadMessagesAsBuyerQueryVariables>;
export function useGetUnreadMessagesAsBuyerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>(GetUnreadMessagesAsBuyerDocument, options);
        }
export type GetUnreadMessagesAsBuyerQueryHookResult = ReturnType<typeof useGetUnreadMessagesAsBuyerQuery>;
export type GetUnreadMessagesAsBuyerLazyQueryHookResult = ReturnType<typeof useGetUnreadMessagesAsBuyerLazyQuery>;
export type GetUnreadMessagesAsBuyerSuspenseQueryHookResult = ReturnType<typeof useGetUnreadMessagesAsBuyerSuspenseQuery>;
export type GetUnreadMessagesAsBuyerQueryResult = Apollo.QueryResult<GetUnreadMessagesAsBuyerQuery, GetUnreadMessagesAsBuyerQueryVariables>;
export const GetUnreadMessagesAsSellerDocument = gql`
    query getUnreadMessagesAsSeller($userId: Int!) {
  allConversations(condition: {sellerId: $userId}) {
    nodes {
      id
      buyerId
      privateMessagesByConversationId(condition: {readAt: null}) {
        nodes {
          id
          senderId
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnreadMessagesAsSellerQuery__
 *
 * To run a query within a React component, call `useGetUnreadMessagesAsSellerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadMessagesAsSellerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadMessagesAsSellerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUnreadMessagesAsSellerQuery(baseOptions: Apollo.QueryHookOptions<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables> & ({ variables: GetUnreadMessagesAsSellerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>(GetUnreadMessagesAsSellerDocument, options);
      }
export function useGetUnreadMessagesAsSellerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>(GetUnreadMessagesAsSellerDocument, options);
        }
// @ts-ignore
export function useGetUnreadMessagesAsSellerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>;
export function useGetUnreadMessagesAsSellerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadMessagesAsSellerQuery | undefined, GetUnreadMessagesAsSellerQueryVariables>;
export function useGetUnreadMessagesAsSellerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>(GetUnreadMessagesAsSellerDocument, options);
        }
export type GetUnreadMessagesAsSellerQueryHookResult = ReturnType<typeof useGetUnreadMessagesAsSellerQuery>;
export type GetUnreadMessagesAsSellerLazyQueryHookResult = ReturnType<typeof useGetUnreadMessagesAsSellerLazyQuery>;
export type GetUnreadMessagesAsSellerSuspenseQueryHookResult = ReturnType<typeof useGetUnreadMessagesAsSellerSuspenseQuery>;
export type GetUnreadMessagesAsSellerQueryResult = Apollo.QueryResult<GetUnreadMessagesAsSellerQuery, GetUnreadMessagesAsSellerQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($userId: Int!) {
  userById(id: $userId) {
    id
    email
    firstname
    lastname
    emailVerified
    identityVerified
    verificationLevel
    averageRating
    totalReviews
    totalSales
    profilePictureUrl
    createdAt
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables> & ({ variables: GetUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
// @ts-ignore
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByIdQuery | undefined, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUserConversationsAsBuyerDocument = gql`
    query getUserConversationsAsBuyer($userId: Int!) {
  allConversations(condition: {buyerId: $userId}, orderBy: UPDATED_AT_DESC) {
    nodes {
      id
      listingId
      buyerId
      sellerId
      createdAt
      updatedAt
      carsForSaleByListingId {
        id
        make
        model
        year
        trim
        price
        imageLoc
      }
      userByBuyerId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
      userBySellerId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
      privateMessagesByConversationId(orderBy: CREATED_AT_DESC, first: 1) {
        nodes {
          id
          content
          senderId
          readAt
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserConversationsAsBuyerQuery__
 *
 * To run a query within a React component, call `useGetUserConversationsAsBuyerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConversationsAsBuyerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConversationsAsBuyerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserConversationsAsBuyerQuery(baseOptions: Apollo.QueryHookOptions<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables> & ({ variables: GetUserConversationsAsBuyerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>(GetUserConversationsAsBuyerDocument, options);
      }
export function useGetUserConversationsAsBuyerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>(GetUserConversationsAsBuyerDocument, options);
        }
// @ts-ignore
export function useGetUserConversationsAsBuyerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>;
export function useGetUserConversationsAsBuyerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsAsBuyerQuery | undefined, GetUserConversationsAsBuyerQueryVariables>;
export function useGetUserConversationsAsBuyerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>(GetUserConversationsAsBuyerDocument, options);
        }
export type GetUserConversationsAsBuyerQueryHookResult = ReturnType<typeof useGetUserConversationsAsBuyerQuery>;
export type GetUserConversationsAsBuyerLazyQueryHookResult = ReturnType<typeof useGetUserConversationsAsBuyerLazyQuery>;
export type GetUserConversationsAsBuyerSuspenseQueryHookResult = ReturnType<typeof useGetUserConversationsAsBuyerSuspenseQuery>;
export type GetUserConversationsAsBuyerQueryResult = Apollo.QueryResult<GetUserConversationsAsBuyerQuery, GetUserConversationsAsBuyerQueryVariables>;
export const GetUserConversationsAsSellerDocument = gql`
    query getUserConversationsAsSeller($userId: Int!) {
  allConversations(condition: {sellerId: $userId}, orderBy: UPDATED_AT_DESC) {
    nodes {
      id
      listingId
      buyerId
      sellerId
      createdAt
      updatedAt
      carsForSaleByListingId {
        id
        make
        model
        year
        trim
        price
        imageLoc
      }
      userByBuyerId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
      userBySellerId {
        id
        firstname
        lastname
        email
        profilePictureUrl
      }
      privateMessagesByConversationId(orderBy: CREATED_AT_DESC, first: 1) {
        nodes {
          id
          content
          senderId
          readAt
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserConversationsAsSellerQuery__
 *
 * To run a query within a React component, call `useGetUserConversationsAsSellerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConversationsAsSellerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConversationsAsSellerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserConversationsAsSellerQuery(baseOptions: Apollo.QueryHookOptions<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables> & ({ variables: GetUserConversationsAsSellerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>(GetUserConversationsAsSellerDocument, options);
      }
export function useGetUserConversationsAsSellerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>(GetUserConversationsAsSellerDocument, options);
        }
// @ts-ignore
export function useGetUserConversationsAsSellerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>;
export function useGetUserConversationsAsSellerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsAsSellerQuery | undefined, GetUserConversationsAsSellerQueryVariables>;
export function useGetUserConversationsAsSellerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>(GetUserConversationsAsSellerDocument, options);
        }
export type GetUserConversationsAsSellerQueryHookResult = ReturnType<typeof useGetUserConversationsAsSellerQuery>;
export type GetUserConversationsAsSellerLazyQueryHookResult = ReturnType<typeof useGetUserConversationsAsSellerLazyQuery>;
export type GetUserConversationsAsSellerSuspenseQueryHookResult = ReturnType<typeof useGetUserConversationsAsSellerSuspenseQuery>;
export type GetUserConversationsAsSellerQueryResult = Apollo.QueryResult<GetUserConversationsAsSellerQuery, GetUserConversationsAsSellerQueryVariables>;